<template>
    <div class="themeTrack-container">
        <headline :params="headLines"></headline>
        <div v-show="showEdit" class="content-container">
            <div class="form-container">
                <ul class="breadTab">
                    <li @click="showEdit = false">首页</li>
                    <li>添加专题</li>
                </ul>
                <div class="form">
                    <div class="input on">
                        <div class="l">关键词名称：<i></i></div>
                        <div class="r">
                            <div class="inputContent">
                                <input maxlength="20" v-model="themeInfo.title" placeholder="不超过20个字" type="text">
                                <p>{{themeInfo.title.length}}/20</p>
                            </div>
                            
                        </div>
                    </div>
                    <div class="input start on">
                        <div class="l">添加关键词：
                            <div class="notice">
                                <i></i>
                                <div class="noticeContent">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAA8UlEQVQoU42QMU7DUBBEZ2wETURBESSQZWRbMdwgN7C4APTQpaRNnQukSAc9XADlBrkBSvRtEYUUpKBANEh8DyKKkUE/kO12Z/Zpdok1FaTBAbR9RaK0lv25MU8uK13DvSTZbfi6B3C00h/fLE9fjHn97XcCwjS6EZjVzYSG03Fx8S8gaEUdkl1XMkm92aQY/ATXusOTpO2V5S3BLScA+ig973z+YEaV/n3Cfhw3d3wNQTbXPXY5lxbvltlzni++2grgh63oTmT7z+WVSGk0nRRnAOwSEKZxV0Bnk+XKI2AwG+c9BsdJRum6lmZTjkR7+QkxsU22I2GcIgAAAABJRU5ErkJggg==" alt="">
                                    <ul>
                                        <li>
                                            <div class="ftitle"><i>1</i>“+”表示“并且”，“|”表示“或”。</div>
                                        </li>
                                        <li>
                                            <div class="ftitle"><i>2</i>什么情况下用“|”：</div>
                                            <div class="fcontent"><i></i>如想关注华为、小米、苹果的新闻，表达式为“华为|小米|苹果”，表示文章中出现“华为”、“小米”、“苹果”任意一个关键词就能监测到。</div>
                                        </li>
                                        <li>
                                            <div class="ftitle"><i>3</i>什么情况下用“+”：</div>
                                            <div class="fcontent"><i></i>如想关注华为手机的新闻，表达式为“华为+手机”，表示文章中同时出现“华为”和“手机”两个关键词才能监测到。</div>
                                        </li>
                                        <li>
                                            <div class="ftitle"><i>4</i>什么情况下同时用到“+”、“|”：</div>
                                            <div class="fcontent"><i></i>如想关注苹果公司的新闻，由于“苹果”也是一种水果，表达式为“苹果+（手机|平板|电脑）”，表示文章中出现“苹果”，同时出现“手机”或者“平板”或者“电脑”中任意一个词，就能监测到。</div>
                                        </li>
                                        <li>
                                            <div class="ftitle"><i>5</i>什么情况下用到排除关键词：</div>
                                            <div class="fcontent"><i></i>如想关注华为、小米、苹果的新闻，但又不想看到内容中有“新品发布”、“手机测评”这种关键词的广告，可以使用排除关键词的方式。 匹配关键词表达式“华为|小米|苹果”，排除关键词表达式“新品发布|手机测评”。</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="r">
                            <div :class="{textarea: true, large: showKeyword}">
                                <textarea ref="keyword" @input="keywordinput" @keydown="keyworddown" v-model="themeInfo.keywords" placeholder="“苹果+（手机|平板）,表示文章中出现”苹果“，同时出现”手机“或者”平板“中任意一词" maxlength="50"></textarea>
                                <i @click="showKeyword = !showKeyword" class="large"></i>
                            </div>
                            <div class="wordBtn">
                                <i @click="addStringTOKeyTextarea('keyword','+')" class="add"></i>
                                <i @click="addStringTOKeyTextarea('keyword','|')" class="filter"></i>
                                <i @click="addStringTOKeyTextarea('keyword','(')" class="leftAbout"></i>
                                <i @click="addStringTOKeyTextarea('keyword',')')" class="rightAbout"></i>
                                <span>最多50个词</span>
                            </div>
                        </div>
                    </div>
                    <div class="input start">
                        <div class="l">添加排除词：
                            <div class="notice">
                                <i></i>
                                <div class="noticeContent">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAA8UlEQVQoU42QMU7DUBBEZ2wETURBESSQZWRbMdwgN7C4APTQpaRNnQukSAc9XADlBrkBSvRtEYUUpKBANEh8DyKKkUE/kO12Z/Zpdok1FaTBAbR9RaK0lv25MU8uK13DvSTZbfi6B3C00h/fLE9fjHn97XcCwjS6EZjVzYSG03Fx8S8gaEUdkl1XMkm92aQY/ATXusOTpO2V5S3BLScA+ig973z+YEaV/n3Cfhw3d3wNQTbXPXY5lxbvltlzni++2grgh63oTmT7z+WVSGk0nRRnAOwSEKZxV0Bnk+XKI2AwG+c9BsdJRum6lmZTjkR7+QkxsU22I2GcIgAAAABJRU5ErkJggg==" alt="">
                                    <ul>
                                        <li>
                                            <div class="ftitle"><i>1</i>“+”表示“并且”，“|”表示“或”。</div>
                                        </li>
                                        <li>
                                            <div class="ftitle"><i>2</i>什么情况下用“|”：</div>
                                            <div class="fcontent"><i></i>如想关注华为、小米、苹果的新闻，表达式为“华为|小米|苹果”，表示文章中出现“华为”、“小米”、“苹果”任意一个关键词就能监测到。</div>
                                        </li>
                                        <li>
                                            <div class="ftitle"><i>3</i>什么情况下用“+”：</div>
                                            <div class="fcontent"><i></i>如想关注华为手机的新闻，表达式为“华为+手机”，表示文章中同时出现“华为”和“手机”两个关键词才能监测到。</div>
                                        </li>
                                        <li>
                                            <div class="ftitle"><i>4</i>什么情况下同时用到“+”、“|”：</div>
                                            <div class="fcontent"><i></i>如想关注苹果公司的新闻，由于“苹果”也是一种水果，表达式为“苹果+（手机|平板|电脑）”，表示文章中出现“苹果”，同时出现“手机”或者“平板”或者“电脑”中任意一个词，就能监测到。</div>
                                        </li>
                                        <li>
                                            <div class="ftitle"><i>5</i>什么情况下用到排除关键词：</div>
                                            <div class="fcontent"><i></i>如想关注华为、小米、苹果的新闻，但又不想看到内容中有“新品发布”、“手机测评”这种关键词的广告，可以使用排除关键词的方式。 匹配关键词表达式“华为|小米|苹果”，排除关键词表达式“新品发布|手机测评”。</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="r">
                            <div :class="{textarea: true, large: showExclude}">
                                <textarea ref="exclude" @input="excludekeywordinput" @keydown="excludekeyworddown" v-model="themeInfo.exclude_keywords" placeholder="新品发布|手机测评，表示文章中出现”新品发布“或手机测评" maxlength="20"></textarea>
                                <i @click="showExclude = !showExclude" class="large"></i>
                            </div>
                            <div class="wordBtn">
                                <i @click="addStringTOExcludeTextarea('exclude','+')" class="add"></i>
                                <i @click="addStringTOExcludeTextarea('exclude','|')" class="filter"></i>
                                <i @click="addStringTOExcludeTextarea('exclude','(')" class="leftAbout"></i>
                                <i @click="addStringTOExcludeTextarea('exclude',')')" class="rightAbout"></i>
                                <span>最多20个词</span>
                            </div>
                        </div>
                    </div>
                    <div class="input on da">
                        <div class="l">起止时间：</div>
                        <div class="r">
                            <div class="date">
                                <!-- <date-picker :disabled-date="disabledDates" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker> -->
                                <el-date-picker
                                    :picker-options="pickerOption"
                                    v-model="datePicker"
                                    type="daterange"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="input start mb40">
                        <div class="l">站点排除：</div>
                        <div class="r">
                            <div :class="{textarea: true, large: showWeb}">
                                <textarea v-model="themeInfo.exclude_web" placeholder="输入网站名称，多个网站请用空格隔开，如人民网 新华网 央视网" maxlength="200"></textarea>
                                <i @click="showWeb = !showWeb" class="large"></i>
                            </div>
                        </div>
                    </div>
                    <div class="input start mb30">
                        <div class="l">账号排除：</div>
                        <div class="r">
                            <div :class="{textarea: true, large: showAccount}">
                                <textarea v-model="themeInfo.exclude_account" placeholder="输入账号名称，多个账号请用空格隔开，如人民日报" maxlength="200"></textarea>
                                <i @click="showAccount = !showAccount" class="large"></i>
                            </div>
                        </div>
                    </div>

                    <div class="submitBtn">
                        <p :class="{un: isEdit}" @click="submitTheme">保存</p>
                        <p @click="showEdit = false">取消</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showSuccessMask" class="successMask">
            <div class="content">
                <div class="icon">
                    <img src="@assets/img/common/ok.svg" alt="ok">
                </div>
                <p class="title">
                    提交成功
                </p>
                <p class="msg">
                    请注意在消息中心查看专题追踪结果
                </p>
                <div class="btns">
                    <p class="cancel" @click="showSuccessMask = false">知道了</p>
                </div>
            </div>
        </div>
        <div v-show="!showEdit" :class="{'content-container': true, fixed: !showEdit}">
            <div class="left-container">
                <div @click="getThemeInfo()" class="addBtn">
                    <i></i>
                    添加专题
                </div>
                <div class="titleTips">
                    关注专题
                </div>
                <ul @scroll="listScroll">
                    <li :class="{on:id == item.id}" @click="changeTheme(index)" v-for="(item,index) in themeList" :key="item.id">
                        <div class="l">{{item.title}}</div>
                        <div class="r">
                            <div v-if="item.status - 0 === 1" class="date">{{item.start}}  至  {{item.end}}</div>
                            <div v-if="item.status - 0 === 1" class="btn">
                                <i @click="getThemeInfo(item.id)" class="edit"></i>
                                <i @click="refreshTheme(item.id)" class="refresh"></i>
                                <i @click="delTheme(item.id)" class="del"></i>
                            </div>
                            <div v-if="item.status - 0 === 2" class="fail">
                                <i></i>
                                创建失败
                            </div>
                            <div v-if="item.status - 0 === 2" class="btn">
                                <i @click="getThemeInfo(item.id)" class="edit"></i>
                                <i @click="delTheme(item.id)" class="del"></i>
                            </div>
                            <div v-if="item.status - 0 === 0" class="load">
                                <i></i>
                                数据分析中…
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="right-container">
                <div v-show="showChart" class="chart-content">
                    <div class="title">
                        <img @click="showChart = false" src="../../assets/img/themeTrack/back.png" alt="">
                        <span>{{title}} </span>
                        <p>总体分析报告</p>
                    </div>
                    <div class="tips">
                        <p v-html="indexChartValue.totalReport"></p>
                        <p>报告更新时间：<span>{{indexChartValue.update_time}}</span></p>
                    </div>
                    <div :style="'font-size:'+fontSize+'px'" class="onChart">
                        <div class="title">
                            <div class="t">趋势分析</div>
                            <div class="b">
                                <i @click="downloadTrendAnalysisChart" class="d"></i>
                                <i @click="exportRes('trendAnalysis')" class="s"></i>
                            </div>
                        </div>
                        <div ref="trendAnalysis" class="content"></div>
                    </div>
                    <div :style="'font-size:'+fontSize+'px'" class="twoChart">
                        <div class="one">
                            <div class="title">
                                <div class="t">渠道趋势分析</div>
                                <div class="b">
                                    <i @click="downloadChannelTrendAnalysisChart" class="d"></i>
                                    <i @click="exportRes('channelTrendAnalysis')" class="s"></i>
                                </div>
                            </div>
                            <div ref="channelTrendAnalysis" class="content"></div>
                        </div>
                        <div class="one">
                            <div class="title">
                                <div class="t">社交趋势分析</div>
                                <div class="b">
                                    <i @click="downloadSocialTrendAnalysisChart" class="d"></i>
                                    <i @click="exportRes('socialTrendAnalysis')" class="s"></i>
                                </div>
                            </div>
                            <div ref="socialTrendAnalysis" class="content"></div>
                        </div>
                    </div>
                    <div :style="'font-size:'+fontSize+'px'" class="twoChart">
                        <div class="one">
                            <div class="title">
                                <div class="t">渠道统计</div>
                                <div class="b">
                                    <i @click="downloadChannelStatisticsChart" class="d"></i>
                                    <i @click="exportRes('channelStatistics')" class="s"></i>
                                </div>
                            </div>
                            <div ref="channelStatistics" class="content"></div>
                        </div>
                        <div class="one">
                            <div class="title">
                                <div class="t">社交渠道统计</div>
                                <div class="b">
                                    <i @click="downloadSocialChannelStatisticsChart" class="d"></i>
                                    <i @click="exportRes('socialChannelStatistics')" class="s"></i>
                                </div>
                            </div>
                            <div ref="socialChannelStatistics" class="content"></div>
                        </div>
                    </div>
                    <div :style="'font-size:'+fontSize+'px'" class="twoChart">
                        <div class="one">
                            <div class="title">
                                <div class="t">情感趋势分析</div>
                                <div class="b">
                                    <i @click="downloadEmoTrendAnalysisChart" class="d"></i>
                                    <i @click="exportRes('emoTrendAnalysis')" class="s"></i>
                                </div>
                            </div>
                            <div ref="emoTrendAnalysis" class="content"></div>
                        </div>
                        <div class="one">
                            <div class="title">
                                <div class="t">情感统计</div>
                                <div class="b">
                                    <i @click="downloadEmoStatisticsChart" class="d"></i>
                                    <i @click="exportRes('emoStatistics')" class="s"></i>
                                </div>
                            </div>
                            <div ref="emoStatistics" class="content"></div>
                        </div>
                    </div>
                    <div :style="'font-size:'+fontSize+'px'" class="twoChart">
                        <div class="one">
                            <div class="title">
                                <div class="t">渠道情感统计</div>
                                <div class="b">
                                    <i @click="downloadChannelEmoStatisticsChart" class="d"></i>
                                    <i @click="exportRes('channelEmoStatistics')" class="s"></i>
                                </div>
                            </div>
                            <div ref="channelEmoStatistics" class="content"></div>
                        </div>
                        <div class="one">
                            <div class="title">
                                <div class="t">社交渠道情感统计</div>
                                <div class="b">
                                    <i @click="downloadSocialChannelEmoStatisticsChart" class="d"></i>
                                    <i @click="exportRes('socialChannelEmoStatistics')" class="s"></i>
                                </div>
                            </div>
                            <div ref="socialChannelEmoStatistics" class="content"></div>
                        </div>
                    </div>
                    <div ref="analysis" :style="'font-size:'+fontSize+'px'" class="analysis">

                    </div>
                </div>
                <div v-show="!showChart && themeList.length > 0" class="article-content">
                    <div class="right-top">
                        <div class="title">
                            <div class="l">{{title}}</div>
                            <div v-show="status-0 == 1" class="r">
                                <div @click="showChart = true" class="word">
                                    <i></i>
                                    总体分析报告
                                </div>
                                <div @click="exportExecl" class="out">
                                    <i></i>
                                    导出报告
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-content" @scroll="articleScroll">
                        <div v-show="status-0 == 2" class="emptyError">
                            <div class="error">
                                <img src="../../assets/img/themeTrack/error.png" alt="">
                                <span>专题创建失败</span>
                            </div>
                            <div class="btn">
                                <p @click="getThemeInfo(id)">修改专题</p>
                                <p @click="delTheme()">删除专题</p>
                            </div>
                        </div>
                        <div v-show="status-0 == 0" class="searching">
                            <div class="search">
                                <img src="../../assets/img/themeTrack/search.png" alt="">
                                <span>专题分析中…</span>
                            </div>
                            <div class="btn">
                                <p @click="getThemeInfo(id)">修改专题</p>
                                <p @click="delTheme()">删除专题</p>
                            </div>
                        </div>
                        <div v-show="status-0 == 1" class="tips">
                            <p v-html="indexChartValue.totalReport"></p>
                            <p>报告更新时间：<span>{{indexChartValue.update_time}}</span></p>
                        </div>
                        <div v-show="status-0 == 1" :style="'font-size:'+fontSize+'px'" class="chart-container">
                            <div class="title">
                                <div class="l">事件总体趋势分析</div>
                                <div class="r">
                                    <i @click="downloadIndexChart" class="d"></i>
                                    <i @click="exportRes('trendAnalysis')" class="s"></i>
                                </div>
                            </div>
                            <div ref="indexChart" class="content"></div>
                        </div>
                        <div v-show="status-0 == 1" class="resultFrom">
                            以下显示<span>新闻、微博、微信、抖音、头条、快手 </span>不同排名top10-20 数据
                        </div>
                        <div v-show="status-0 == 1" class="filter-container">
                            <div v-click-outside="hideShowType" class="all">
                                <p @click="showType = !showType">
                                    {{typeList && typeList[typeIndex] && typeList[typeIndex].val}}
                                    <i></i>
                                </p>
                                <ul v-if="showType">
                                    <li @click="selectTypeIndex(index)" v-for="(item,index) in typeList" :class="{on:typeIndex == index }" :key="index">{{item.val}}
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                            <div v-click-outside="hideShowTime" :class="{time: true,un: typeIndex != 0}">
                                <p @click="toggleShowTime">
                                    {{orderbyList && orderbyList[orderbyIndex] && orderbyList[orderbyIndex].val}}
                                    <i></i>
                                </p>
                                <ul v-if="showTime">
                                    <li @click="selectOrderbyIndex(index)" v-for="(item,index) in orderbyList" :class="{on:orderbyIndex == index }" :key="index">{{item.val}}
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                            <div v-click-outside="hideShowEmotion" :class="{emotion: true,un: typeIndex != 0}">
                                <p @click="toggleShowEmotion">
                                    {{emotionList && emotionList[emotionIndex] && emotionList[emotionIndex].val}}
                                    <i></i>
                                </p>
                                <ul v-if="showEmotion">
                                    <li @click="selectEmotionIndex(index)" v-for="(item,index) in emotionList" :class="{on:emotionIndex == index }" :key="index">{{item.val}}
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="topNumList.length > 0" v-click-outside="hideShowTop" :class="{topNum: true}">
                                <p @click="showTop = !showTop">
                                    {{topNumList && topNumList[topNumIndex] && topNumList[topNumIndex].val}}
                                    <i></i>
                                </p>
                                <ul v-if="showTop">
                                    <li @click="selectTopIndex(index)" v-for="(item,index) in topNumList" :class="{on:topNumIndex == index }" :key="index">{{item.val}}
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <ul v-show="status-0 == 1" class="list-container">
                            <template v-for="(item,index) in list">
                                <li v-if="item.cover" @click="showDetail(item.id, item.contentType)" class="textImg">
                                    <p v-if="typeIndex != 0" :class="{un: index > 2}">{{++index}}</p>
                                    <div class="l">
                                        <div class="title">{{item.title}}</div>
                                        <div class="content">{{item.info}}</div>
                                        <div class="type-container">
                                            <p v-if="item.type" class="tag">{{item.type}}</p>
                                            <p v-if="item.siteName && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'toutiao' && item.mediaType != 'weixin' && item.mediaType != 'kuaishou'" class="upload">{{item.siteName}}</p>
                                            <p v-if="item.author" class="user">{{item.author}}</p>
                                            <p v-if="item.time" class="time">{{item.time}}</p>
                                            <p v-if="item.playNum && item.mediaType == 'kuaishou'" class="play">{{item.playNum}}</p>
                                            <p v-if="item.similarNum && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'toutiao' && item.mediaType != 'weixin' && item.mediaType != 'kuaishou'" class="connect">{{item.similarNum}}</p>
                                            <p v-if="item.readNum && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'xinwen' && item.mediaType != 'kuaishou'" class="read">{{item.readNum}}</p>
                                            <p v-if="item.readingNum && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'xinwen' && item.mediaType != 'toutiao' && item.mediaType != 'kuaishou'" class="see">{{item.readingNum}}</p>
                                            <p v-if="item.shareNum && item.mediaType != 'xinwen' && item.mediaType != 'toutiao' && item.mediaType != 'weixin'" class="share">{{item.shareNum}}</p>
                                            <p v-if="item.commentNum && item.mediaType != 'xinwen' && item.mediaType != 'weixin'" class="comment">{{item.commentNum}}</p>
                                            <p v-if="item.likeNum && item.mediaType != 'xinwen' && item.mediaType != 'toutiao'" class="fav">{{item.likeNum}}</p>
                                            <p v-if="item.emotion" :class="{status: true, high: item.emotion == '正面', normal: item.emotion == '中性', low: item.emotion == '负面'}">{{item.emotion}}</p>
                                        </div>
                                    </div>
                                    <div class="r">
                                        <img :src="item.cover" alt="">
                                    </div>
                                </li>
                                <li v-else-if="item.pics.length > 0" @click="showDetail(item.id, item.contentType)" class="img">
                                    <p v-if="typeIndex != 0" :class="{un: index > 2}">{{++index}}</p>
                                    <div class="title">{{item.title}}</div>
                                    <div class="imgList">
                                        <img v-for="(items,i) in item.pics" :key="i" :src="items" alt="">
                                    </div>
                                    <div class="type-container">
                                        <p v-if="item.type" class="tag">{{item.type}}</p>
                                        <p v-if="item.siteName && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'toutiao' && item.mediaType != 'weixin' && item.mediaType != 'kuaishou'" class="upload">{{item.siteName}}</p>
                                        <p v-if="item.author" class="user">{{item.author}}</p>
                                        <p v-if="item.time" class="time">{{item.time}}</p>
                                        <p v-if="item.playNum && item.mediaType == 'kuaishou'" class="play">{{item.playNum}}</p>
                                        <p v-if="item.similarNum && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'toutiao' && item.mediaType != 'weixin' && item.mediaType != 'kuaishou'" class="connect">{{item.similarNum}}</p>
                                        <p v-if="item.readNum && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'xinwen' && item.mediaType != 'kuaishou'" class="read">{{item.readNum}}</p>
                                        <p v-if="item.readingNum && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'xinwen' && item.mediaType != 'toutiao' && item.mediaType != 'kuaishou'" class="see">{{item.readingNum}}</p>
                                        <p v-if="item.shareNum && item.mediaType != 'xinwen' && item.mediaType != 'toutiao' && item.mediaType != 'weixin'" class="share">{{item.shareNum}}</p>
                                        <p v-if="item.commentNum && item.mediaType != 'xinwen' && item.mediaType != 'weixin'" class="comment">{{item.commentNum}}</p>
                                        <p v-if="item.likeNum && item.mediaType != 'xinwen' && item.mediaType != 'toutiao'" class="fav">{{item.likeNum}}</p>
                                        <p v-if="item.emotion" :class="{status: true, high: item.emotion == '正面', normal: item.emotion == '中性', low: item.emotion == '负面'}">{{item.emotion}}</p>
                                    </div>
                                </li>
                                <li v-else class="text" @click="showDetail(item.id, item.contentType)">
                                    <p v-if="typeIndex != 0" :class="{un: index > 2}">{{++index}}</p>
                                    <div v-if="item.title" class="title">{{item.title}}</div>
                                    <div v-if="item.info" class="content">{{item.info}}</div>
                                    <div class="type-container">
                                        <p v-if="item.type" class="tag">{{item.type}}</p>
                                        <p v-if="item.siteName && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'toutiao' && item.mediaType != 'weixin' && item.mediaType != 'kuaishou'" class="upload">{{item.siteName}}</p>
                                        <p v-if="item.author" class="user">{{item.author}}</p>
                                        <p v-if="item.time" class="time">{{item.time}}</p>
                                        <p v-if="item.playNum && item.mediaType == 'kuaishou'" class="play">{{item.playNum}}</p>
                                        <p v-if="item.similarNum && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'toutiao' && item.mediaType != 'weixin' && item.mediaType != 'kuaishou'" class="connect">{{item.similarNum}}</p>
                                        <p v-if="item.readNum && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'xinwen' && item.mediaType != 'kuaishou'" class="read">{{item.readNum}}</p>
                                        <p v-if="item.readingNum && item.mediaType != 'weibo' && item.mediaType != 'douyin' && item.mediaType != 'xinwen' && item.mediaType != 'toutiao' && item.mediaType != 'kuaishou'" class="see">{{item.readingNum}}</p>
                                        <p v-if="item.shareNum && item.mediaType != 'xinwen' && item.mediaType != 'toutiao' && item.mediaType != 'weixin'" class="share">{{item.shareNum}}</p>
                                        <p v-if="item.commentNum && item.mediaType != 'xinwen' && item.mediaType != 'weixin'" class="comment">{{item.commentNum}}</p>
                                        <p v-if="item.likeNum && item.mediaType != 'xinwen' && item.mediaType != 'toutiao'" class="fav">{{item.likeNum}}</p>
                                        <p v-if="item.emotion" :class="{status: true, high: item.emotion == '正面', normal: item.emotion == '中性', low: item.emotion == '负面'}">{{item.emotion}}</p>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import headline from "@components/headline";
import DatePicker from 'vue2-datepicker';
import * as echarts from 'echarts';
import { WordCloud } from '@antv/g2plot';
import vClickOutside from "v-click-outside";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        headline,
        DatePicker
    },
    watch: {
        showEdit(to) {
            if(!to) {
                this.datePicker = ''
                this.themeInfo = {
                    id: '',
                    title: '',
                    keywords: '',
                    start: '',
                    end: '',
                    exclude_keywords: '',
                    exclude_web: '',
                    exclude_account: ''
                }
            }
        },
        datePicker: {
            deep: true,
            handler: function(n) {
                console.log(n)
                if(n){
                    this.page.pageIndex = 1
                    this.themeInfo.start = n[0]
                    this.themeInfo.end = n[1]
                }else{
                    this.page.pageIndex = 1
                    this.themeInfo.start = ''
                    this.themeInfo.end = ''
                }
                // this.getList()
            }
        },
        themeInfo: {
            deep: true,
            handler: function(n) {
                if(this.saveThemeInfo.title != this.themeInfo.title || this.saveThemeInfo.keywords != this.themeInfo.keywords || this.saveThemeInfo.start != this.themeInfo.start || this.saveThemeInfo.end != this.themeInfo.end || this.saveThemeInfo.exclude_keywords != this.themeInfo.exclude_keywords || this.saveThemeInfo.exclude_web != this.themeInfo.exclude_web || this.saveThemeInfo.exclude_account != this.themeInfo.exclude_account){
                    this.isEdit = false
                }else{
                    this.isEdit = true
                }
            }
        },
        showChart(to) {
            if(to) {
                this.getChart(this.id)
            }else{
                if(this.wordCloud){
                    this.wordCloud.destroy();
                    this.wordCloud = null
                }
            }
        }
    },
    data() {
        return {
            isEdit: false,
            showSuccessMask: false,
            pickerOption: {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() < new Date(today.getTime() - 99 * 24 * 3600 * 1000) || time.getTime() > new Date(today.getTime())
                }
            },
            showType: false,
            showTime: false,
            showEmotion: false,
            showTop: false,
            indexChartValue: {},
            wordCloud: null,
            indexChartChart: null,
            trendAnalysisChart: null,
            channelTrendAnalysisChart: null,
            socialTrendAnalysisChart: null,
            emoTrendAnalysisChart: null,
            channelStatisticsChart: null,
            socialChannelStatisticsChart: null,
            emoStatisticsChart: null,
            channelEmoStatisticsChart: null,
            socialChannelEmoStatisticsChart: null,
            showKeyword: false,
            showExclude: false,
            showWeb: false,
            showAccount: false,
            showEdit: false,
            themeList: [],
            datePicker: '',
            saveThemeInfo: {
                id: '',
                title: '',
                keywords: '',
                start: '',
                end: '',
                exclude_keywords: '',
                exclude_web: '',
                exclude_account: ''
            },
            themeInfo: {
                id: '',
                title: '',
                keywords: '',
                start: '',
                end: '',
                exclude_keywords: '',
                exclude_web: '',
                exclude_account: ''
            },
            start: '',
            end: '',
            headLines: {
                title: "专题追踪",
                showLink: false,
                filter: false
            },
            page: {
                pageIndex: 1,
                pageCount: 0,
                pageSize: 99,
                total: 0
            },
            listPage: {
                pageIndex: 1,
                pageCount: 0,
                pageSize: 10,
                total: 0
            },
            fontSize: 100,
            showChart: false,
            status: 99,
            id: '',
            title: '',
            typeIndex: 0,
            orderbyIndex: 0,
            emotionIndex: 0,
            topNumIndex: 0,
            typeList: [],
            orderbyList: [],
            emotionList: [],
            topNumList: [],
            list: []
        }
    },
    methods: {
        disabledDates(date) {
            const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000);
        },
        exportExecl(){
            let info = {
                id: this.id
            }
            const userKeys = common.userKeys()
            const params = Object.assign({}, info, userKeys)
            const url = apis.downloadreport
            common.exportRes(url, params)
        },
        exportRes(type) {
            // 导出
            const info = {
                id: this.id,
                type: type
            }
            const userKeys = common.userKeys()
            const params = Object.assign({}, info, userKeys, this.searchOptions, this.filterOptions)
            const url = apis.downloadexecl
            // const url = apis.Res_resource_list + common.obj2Str(params)
            //
            // window.open(url)
            common.exportRes(url, params)
        },
        selectTypeIndex(index) {
            this.typeIndex = index;
            this.topNumList = this.typeList[index].list;
            this.topNumIndex = 0;
            this.orderbyIndex = 0;
            this.emotionIndex = 0;
            this.listPage.pageIndex = 1;
            this.listPage.pageSize = 10;
            this.showType = false;
            this.getIndex(this.id)
        },
        selectOrderbyIndex(index) {
            this.orderbyIndex = index;
            this.showTime = false;
            this.listPage.pageIndex = 1;
            this.listPage.pageSize = 10;
            this.getIndex(this.id)
        },
        selectEmotionIndex(index) {
            this.emotionIndex = index;
            this.showEmotion = false;
            this.listPage.pageIndex = 1;
            this.listPage.pageSize = 10;
            this.getIndex(this.id)
        },
        selectTopIndex(index) {
            this.topNumIndex = index;
            this.showTop = false;
            this.listPage.pageIndex = 1;
            this.listPage.pageSize = 10;
            this.getIndex(this.id)
        },
        articleScroll(e) {
            // console.log(e)
            if (e.srcElement.scrollTop + e.srcElement.clientHeight == e.srcElement.scrollHeight) {
                this.listPage.pageIndex ++
                if(this.listPage.pageIndex <= this.listPage.pageCount){
                    this.getIndex(this.id)
                }
            }
        },
        listScroll(e) {
            // console.log(e)
            if (e.srcElement.scrollTop + e.srcElement.clientHeight == e.srcElement.scrollHeight) {
                this.page.pageIndex ++
                if(this.page.pageIndex < this.page.pageCount){
                    this.getThemes()
                }
            }
        },
        toggleShowTime() {
            if(this.typeIndex == 0){
                this.showTime = !this.showTime
            }
        },
        toggleShowEmotion() {
            if(this.typeIndex == 0){
                this.showEmotion = !this.showEmotion
            }
        },
        showDetail(id, type) {
            let info = {
                id: id
            }
            if(type === 'content'){
                common.myFetch(apis.rankdetail, info).then(res => {
                    if(res){
                        // console.log(res)
                        this.$ArticlePreview(res.detail)
                    }
                })
            }else{
                common.myFetch(apis.rankvideo, info).then(res => {
                    if(res){
                        // console.log(res)
                        res.detail.noVideoBtn = true;
                        this.$MediaPreview(res.detail)
                    }
                })
            }
        },
        hideShowType() {
            this.showType = false
        },
        hideShowTime() {
            this.showTime = false
        },
        hideShowEmotion() {
            this.showEmotion = false
        },
        hideShowTop() {
            this.showTop = false
        },
        changeTheme(index) {
            this.showChart = false;
            this.status = this.themeList[index].status;
            this.id = this.themeList[index].id;
            this.title = this.themeList[index].title;
            this.typeIndex = 0;
            this.orderbyIndex = 0;
            this.emotionIndex = 0;
            this.topNumIndex = 0;
            this.topNumList = [];
            this.listPage.pageIndex = 1;
            this.listPage.pageSize = 10;
            this.getIndex(this.id)
            this.getIndexChart(this.id)
        },
        getTrendAnalysis(list) {
            var chartDom = this.$refs.trendAnalysis;
            var trendAnalysisChart = echarts.init(chartDom);
            let nameList = [];
            let valueList = [];

            list.forEach(el => {
                nameList.push(el.date)
                valueList.push(el.num)
            })

            var option;
            option = {
                color: ['#41B48C'],
                tooltip: {
                    trigger: 'axis',
                    showContent: true
                },
                xAxis: {
                    type: 'category',
                    data: nameList
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: valueList,
                        type: 'line',
                        smooth: true,
                        areaStyle: {}
                    }
                ]
            };
            trendAnalysisChart.setOption(option);

            this.trendAnalysisChart = trendAnalysisChart

            // window.onresize = () => {
            //     this.trendAnalysisChart.resize()
            // }
        },
        getChannelTrendAnalysis(list) {
            var chartDom = this.$refs.channelTrendAnalysis;
            // console.log(chartDom)
            var channelTrendAnalysisChart = echarts.init(chartDom);

            let data = ['来源']
            let lt = ['论坛']
            let wz = ['网站']
            let dzb = ['电子报']
            let sp = ['视频']
            let khd = ['客户端']

            list.forEach(el => {
                data.push(el.date)
                lt.push(el.list.lt)
                wz.push(el.list.wz)
                dzb.push(el.list.dzb)
                sp.push(el.list.sp)
                khd.push(el.list.khd)
            })

            var option;
            option = {
                legend: {},
                tooltip: {
                    trigger: 'axis',
                    showContent: true
                },
                dataset: {
                    source: [
                        data,
                        lt,
                        wz,
                        dzb,
                        sp,
                        khd
                    ]
                },
                xAxis: { type: 'category' },
                yAxis: { gridIndex: 0 },
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    }
                ]
            };
            channelTrendAnalysisChart.setOption(option);

            this.channelTrendAnalysisChart = channelTrendAnalysisChart

            // window.onresize = () => {
            //     channelTrendAnalysisChart.resize()
            // }
        },
        getSocialTrendAnalysis(list) {
            var chartDom = this.$refs.socialTrendAnalysis;
            // console.log(chartDom)
            var socialTrendAnalysisChart = echarts.init(chartDom);

            let data = ['来源']
            let dy = ['抖音']
            let tt = ['头条']
            let wb = ['微博']
            let zh = ['知乎']
            let wx = ['微信']
            let ks = ['快手']

            list.forEach(el => {
                data.push(el.date)
                dy.push(el.list.dy)
                tt.push(el.list.tt)
                wb.push(el.list.wb)
                zh.push(el.list.zh)
                wx.push(el.list.wx)
                ks.push(el.list.ks)
            })

            var option;
            option = {
                legend: {},
                tooltip: {
                    trigger: 'axis',
                    showContent: true
                },
                dataset: {
                    source: [
                        data,
                        dy,
                        tt,
                        wb,
                        zh,
                        wx,
                        ks
                    ]
                },
                xAxis: { type: 'category' },
                yAxis: { gridIndex: 0 },
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    }
                ]
            };
            socialTrendAnalysisChart.setOption(option);

            this.socialTrendAnalysisChart = socialTrendAnalysisChart

            // window.onresize = () => {
            //     channelTrendAnalysisChart.resize()
            // }
        },
        getEmoTrendAnalysis(list) {
            var chartDom = this.$refs.emoTrendAnalysis;
            // console.log(chartDom)
            var emoTrendAnalysisChart = echarts.init(chartDom);

            let data = ['来源']
            let zm = ['正面']
            let fm = ['负面']
            let zx = ['中性']

            list.forEach(el => {
                data.push(el.date)
                zm.push(el.list.zm)
                fm.push(el.list.fm)
                zx.push(el.list.zx)
            })

            var option;
            option = {
                legend: {},
                tooltip: {
                    trigger: 'axis',
                    showContent: true
                },
                dataset: {
                    source: [
                        data,
                        zm,
                        fm,
                        zx
                    ]
                },
                xAxis: { type: 'category' },
                yAxis: { gridIndex: 0 },
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    },
                    {
                        type: 'line',
                        smooth: true,
                        seriesLayoutBy: 'row',
                        emphasis: { focus: 'series' }
                    }
                ]
            };
            emoTrendAnalysisChart.setOption(option);

            this.emoTrendAnalysisChart = emoTrendAnalysisChart

            // window.onresize = () => {
            //     channelTrendAnalysisChart.resize()
            // }
        },
        getChannelStatisticsChart(list) {
            var chartDom = this.$refs.channelStatistics;
            // console.log(chartDom)
            var channelStatisticsChart = echarts.init(chartDom);

            var option

            option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [
                    {
                        name: '渠道统计',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                            show: true,
                            fontSize: '14',
                            fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: list.wz, name: '网站' },
                            { value: list.lt, name: '论坛' },
                            { value: list.sp, name: '视频' },
                            { value: list.khd, name: '客户端' },
                            { value: list.dzb, name: '电子报' }
                        ]
                    }
                ]
            };
            channelStatisticsChart.setOption(option);

            this.channelStatisticsChart = channelStatisticsChart

            // window.onresize = () => {
            //     channelTrendAnalysisChart.resize()
            // }
        },
        getSocialChannelStatistics(list) {
            var chartDom = this.$refs.socialChannelStatistics;
            // console.log(chartDom)
            var socialChannelStatisticsChart = echarts.init(chartDom);

            var option

            option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [
                    {
                        name: '社交渠道统计',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                            show: true,
                            fontSize: '14',
                            fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: list.wb, name: '微博' },
                            { value: list.wx, name: '微信' },
                            { value: list.dy, name: '抖音' },
                            { value: list.tt, name: '头条' },
                            { value: list.ks, name: '快手' },
                            { value: list.zh, name: '知乎' }
                        ]
                    }
                ]
            };
            socialChannelStatisticsChart.setOption(option);

            this.socialChannelStatisticsChart = socialChannelStatisticsChart

            // window.onresize = () => {
            //     channelTrendAnalysisChart.resize()
            // }
        },
        getEmoStatistics(list) {
            var chartDom = this.$refs.emoStatistics;
            // console.log(chartDom)
            var emoStatisticsChart = echarts.init(chartDom);

            var option

            option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [
                    {
                        name: '情感统计',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                            show: true,
                            fontSize: '14',
                            fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: list.zm, name: '正面' },
                            { value: list.zx, name: '中性' },
                            { value: list.fm, name: '负面' }
                        ]
                    }
                ]
            };
            emoStatisticsChart.setOption(option);

            this.emoStatisticsChart = emoStatisticsChart

            // window.onresize = () => {
            //     channelTrendAnalysisChart.resize()
            // }
        },
        getChannelEmoStatistics(list) {
            var chartDom = this.$refs.channelEmoStatistics;
            // console.log(chartDom)
            var channelEmoStatisticsChart = echarts.init(chartDom);

            let name = []

            let arr = [['渠道情感分析', '负面', '非负面']]

            list.forEach(el => {
                name.push(el.platform)
                arr.push([el.platform,el.list.fm,el.list.ffm])
            })

            var option

            option = {
                legend: {},
                tooltip: {},
                dataset: {
                    source: arr
                },
                xAxis: { type: 'category' },
                yAxis: {},
                // Declare several bar series, each will be mapped
                // to a column of dataset.source by default.
                series: [{ type: 'bar' }, { type: 'bar' }]
            };

            channelEmoStatisticsChart.setOption(option);

            this.channelEmoStatisticsChart = channelEmoStatisticsChart

            // window.onresize = () => {
            //     channelTrendAnalysisChart.resize()
            // }
        },
        getSocialChannelEmoStatistics(list) {
            var chartDom = this.$refs.socialChannelEmoStatistics;
            // console.log(chartDom)
            var socialChannelEmoStatisticsChart = echarts.init(chartDom);

            let name = []

            let arr = [['社交渠道情感分析', '负面', '非负面']]

            list.forEach(el => {
                name.push(el.platform)
                arr.push([el.platform,el.list.fm,el.list.ffm])
            })

            var option

            option = {
                legend: {},
                tooltip: {},
                dataset: {
                    source: arr
                },
                xAxis: { type: 'category' },
                yAxis: {},
                // Declare several bar series, each will be mapped
                // to a column of dataset.source by default.
                series: [{ type: 'bar' }, { type: 'bar' }]
            };

            socialChannelEmoStatisticsChart.setOption(option);

            this.socialChannelEmoStatisticsChart = socialChannelEmoStatisticsChart

            // window.onresize = () => {
            //     channelTrendAnalysisChart.resize()
            // }
        },
        getCloudWord(list) {
            let arr = []
            list.forEach(el => {
                arr.push({
                    value: el.num,
                    name: el.keyword
                })
            })
            // console.log(arr,this.$refs.analysis)
            const wordCloud = new WordCloud(this.$refs.analysis, {
                data: arr,
                autoFit: true,
                wordField: 'name',
                weightField: 'value',
                colorField: 'name',
                wordStyle: {
                    fontFamily: 'Verdana',
                    fontSize: [14, 32],
                    rotation: 0,
                },
                // 返回值设置成一个 [0, 1) 区间内的值，
                // 可以让每次渲染的位置相同（前提是每次的宽高一致）。
                random: () => 0.5,
            });

            wordCloud.render();

            this.wordCloud = wordCloud
        },
        downloadTrendAnalysisChart() {
            let img = new Image();
            img.src = this.trendAnalysisChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        downloadChannelTrendAnalysisChart() {
            let img = new Image();
            img.src = this.channelTrendAnalysisChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        downloadSocialTrendAnalysisChart() {
            let img = new Image();
            img.src = this.socialTrendAnalysisChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        downloadEmoTrendAnalysisChart() {
            let img = new Image();
            img.src = this.emoTrendAnalysisChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        downloadChannelStatisticsChart() {
            let img = new Image();
            img.src = this.channelStatisticsChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        downloadSocialChannelStatisticsChart() {
            let img = new Image();
            img.src = this.socialChannelStatisticsChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        downloadEmoStatisticsChart() {
            let img = new Image();
            img.src = this.emoStatisticsChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        downloadChannelEmoStatisticsChart() {
            let img = new Image();
            img.src = this.channelEmoStatisticsChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        downloadSocialChannelEmoStatisticsChart() {
            let img = new Image();
            img.src = this.socialChannelEmoStatisticsChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        downloadIndexChart() {
            let img = new Image();
            img.src = this.indexChartChart.getDataURL({
                type: "png",
                pixelRatio: 1, //放大2倍
                backgroundColor: '#fff'
            });

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/png');

                let a = document.createElement('a');
                // 创建一个单击事件
                let event = new MouseEvent('click');
                // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                a.download = '图片.png';
                // 将生成的URL设置为a.href属性
                a.href = dataURL;
                // 触发a的单击事件
                a.dispatchEvent(event);
            }
        },
        recalc() {

            if(this.indexChartChart){
                this.indexChartChart.resize()
            }

            if(this.trendAnalysisChart){
                this.trendAnalysisChart.resize()
            }

            if(this.channelTrendAnalysisChart){
                this.channelTrendAnalysisChart.resize()
            }

            if(this.socialTrendAnalysisChart){
                this.socialTrendAnalysisChart.resize()
            }

            if(this.emoTrendAnalysisChart){
                this.emoTrendAnalysisChart.resize()
            }

            if(this.channelStatisticsChart){
                this.channelStatisticsChart.resize()
            }

            if(this.socialChannelStatisticsChart){
                this.socialChannelStatisticsChart.resize()
            }

            if(this.emoStatisticsChart){
                this.emoStatisticsChart.resize()
            }

            if(this.channelEmoStatisticsChart){
                this.channelEmoStatisticsChart.resize()
            }

            if(this.socialChannelEmoStatisticsChart){
                this.socialChannelEmoStatisticsChart.resize()
            }

            var clientWidth = document.documentElement.clientWidth;

            if (!clientWidth) {

                return;
            }

            var p = 100 * (clientWidth / 1334);

            if(p < 100){
                p = 100
            }else if(p > 130){
                p = 130
            }

            this.fontSize = p
        },
        submitTheme() {
            if(this.saveThemeInfo.title == this.themeInfo.title && this.saveThemeInfo.keywords == this.themeInfo.keywords && this.saveThemeInfo.start == this.themeInfo.start && this.saveThemeInfo.end == this.themeInfo.end && this.saveThemeInfo.exclude_keywords == this.themeInfo.exclude_keywords && this.saveThemeInfo.exclude_web == this.themeInfo.exclude_web && this.saveThemeInfo.exclude_account == this.themeInfo.exclude_account) return
            common.myFetch(apis.sentimentEdittheme,this.themeInfo).then(res => {
                if(res){
                    console.log(res)
                    // this.$toast(res)
                    this.showSuccessMask = true
                    this.getThemes()
                    this.showEdit = false;
                    this.datePicker = ''
                    this.themeInfo = {
                        id: '',
                        title: '',
                        keywords: '',
                        start: '',
                        end: '',
                        exclude_keywords: '',
                        exclude_web: '',
                        exclude_account: ''
                    }
                }
            })
        },
        addStringTOKeyTextarea(r,str){
            var tc = this.$refs[r];
            var tclen = tc.value.length;
            tc.focus();
            if(typeof document.selection != "undefined"){
                document.selection.createRange().text = str;  
            }else{
                this.themeInfo.keywords = this.themeInfo.keywords.substr(0,tc.selectionStart)+str+this.themeInfo.keywords.substring(tc.selectionStart,tclen);
            }
        },
        addStringTOExcludeTextarea(r,str){
            var tc = this.$refs[r];
            var tclen = tc.value.length;
            tc.focus();
            if(typeof document.selection != "undefined"){
                document.selection.createRange().text = str;  
            }else{
                this.themeInfo.exclude_keywords = this.themeInfo.exclude_keywords.substr(0,tc.selectionStart)+str+this.themeInfo.exclude_keywords.substring(tc.selectionStart,tclen);
            }
        },
        keywordinput(e) {
            this.themeInfo.keywords = this.themeInfo.keywords.replace('（', '')
            this.themeInfo.keywords = this.themeInfo.keywords.replace('）', '')
        },
        keyworddown(e) {
            if(e.key == '+' || e.key == '(' || e.key == ')' || e.key == '|'){
                e.preventDefault()
            }
        },  
        excludekeywordinput(e) {
            this.themeInfo.exclude_keywords = this.themeInfo.exclude_keywords.replace('（', '')
            this.themeInfo.exclude_keywords = this.themeInfo.exclude_keywords.replace('）', '')
        },
        excludekeyworddown(e) {
            if(e.key == '+' || e.key == '(' || e.key == ')' || e.key == '|'){
                e.preventDefault()
            }
        }, 
        getThemesDetail(id) {
            let info = {
                id: id
            }
            common.myFetch(apis.sentimentRankdetail,info).then(res => {
                if(res){
                    console.log(res)
                    
                }
            })
        },
        getChart(id) {
            let info = {
                id: id
            }
            common.myFetch(apis.sentimentThemedetail, info).then(res => {
                if(res){
                    console.log(res)
                    this.$nextTick(() => {
                        this.getTrendAnalysis(res.trendAnalysis)
                        this.getChannelTrendAnalysis(res.channelTrendAnalysis)
                        this.getSocialTrendAnalysis(res.socialTrendAnalysis)
                        this.getEmoTrendAnalysis(res.emoTrendAnalysis)
                        this.getChannelStatisticsChart(res.channelStatistics)
                        this.getSocialChannelStatistics(res.socialChannelStatistics)
                        this.getEmoStatistics(res.emoStatistics)
                        this.getChannelEmoStatistics(res.channelEmoStatistics)
                        this.getSocialChannelEmoStatistics(res.socialChannelEmoStatistics)
                        this.getCloudWord(res.words)
                    })
                    
                }
            })
        },
        getIndexChart(id) {
            let info = {
                id: id
            }
            common.myFetch(apis.sentimentThemedetail, info).then(res => {
                if(res){
                    console.log(res)
                    this.indexChartValue = res;
                    this.$nextTick(() => {
                        var list = res.trendAnalysis;
                        var chartDom = this.$refs.indexChart;
                        var indexChartChart = echarts.init(chartDom);
                        let nameList = [];
                        let valueList = [];

                        list.forEach(el => {
                            nameList.push(el.date)
                            valueList.push(el.num)
                        })

                        var option;
                        option = {
                            color: ['#41B48C'],
                            tooltip: {
                                trigger: 'axis',
                                showContent: true
                            },
                            xAxis: {
                                type: 'category',
                                data: nameList
                            },
                            yAxis: {
                                type: 'value'
                            },
                            series: [
                                {
                                    data: valueList,
                                    type: 'line',
                                    smooth: true,
                                    areaStyle: {}
                                }
                            ]
                        };
                        indexChartChart.setOption(option);

                        this.indexChartChart = indexChartChart
                    })
                    
                }
            })
        },
        getThemeInfo(id) {
            // console.log(id)
            this.showEdit = !this.showEdit
            if(!id) return
            let info = {
                id: id
            }
            common.myFetch(apis.sentimentThemeinfo,info).then(res => {
                if(res){
                    console.log(res)
                    this.isEdit = true
                    let data = res.detail
                    this.saveThemeInfo = JSON.parse(JSON.stringify(data)) 
                    this.themeInfo = res.detail
                    // this.datePicker = [new Date(res.detail.start), new Date(res.detail.end)]
                    this.datePicker = [res.detail.start, res.detail.end]
                    // this.themeInfo.start = res.detail.start
                    // this.themeInfo.end = res.detail.end
                }
            })
        },
        delTheme(id) {
            let delId = id || this.id
            let info = {
                id: delId
            }
            common.myFetch(apis.sentimentDel,info).then(res => {
                if(res){
                    this.$toast('删除成功')
                    this.page.pageIndex = 1
                    this.getThemes()
                }
            })
        },
        refreshTheme(id) {
            let reId = id || this.id
            let info = {
                id: reId
            }
            common.myFetch(apis.sentimentReupdate,info).then(res => {
                if(res){
                    this.$toast('刷新成功')
                    this.page.pageIndex = 1
                    this.getThemes()
                }
            })
        },
        getIndex(id) {
            let info = {
                id: id,
                type: this.typeList && this.typeList[this.typeIndex] && this.typeList[this.typeIndex].key || '',
                orderby: this.orderbyList && this.orderbyList[this.orderbyIndex] && this.orderbyList[this.orderbyIndex].key || '',
                emotion: this.emotionList && this.emotionList[this.emotionIndex] && this.emotionList[this.emotionIndex].key || '',
                topNum: this.topNumList && this.topNumList[this.topNumIndex] && this.topNumList[this.topNumIndex].key || '',
                page: this.listPage.pageIndex,
                pagesize: this.listPage.pageSize
            }
            common.myFetch(apis.sentimentRanks,info).then(res => {
                if(res){
                    if(this.listPage.pageIndex == 1){
                        this.list = res.list;
                    }else{
                        let list = this.list
                        this.list = list.concat(res.list);
                    }
                    res.params.list_search.forEach(el => {
                        if(el.key === 'type'){
                            this.typeList = el.list
                        }else if(el.key === 'orderby'){
                            this.orderbyList = el.list
                            el.list.forEach((v,i) => {
                                if(v.selected){
                                    this.orderbyIndex = i
                                }
                            })
                        }else if(el.key === 'emotion'){
                            this.emotionList = el.list
                        }
                    })

                    console.log(this.typeList)

                    this.$set(
                        this.listPage,
                        "pageCount",
                        common.calculatePage(res.page.row_count - 0, this.listPage.pageSize)
                    );
                    this.$set(this.page, "total", res.page.row_count - 0);
                }
                console.log(res)
            })
        },
        getThemes() {
            let info = {
                page: this.page.pageIndex,
                pagesize: this.page.pageSize
            }
            common.myFetch(apis.sentimentThemes,info).then(res => {
                if(res){
                    if(this.page.pageIndex == 1){
                        this.themeList = res.list;
                    }else{
                        let list = this.themeList;
                        this.themeList = list.concat(res.list);
                    }
                    
                    this.$set(
                        this.page,
                        "pageCount",
                        common.calculatePage(res.pages.row_count - 0, this.page.pageSize)
                    );
                    this.$set(this.page, "total", res.pages.row_count - 0);
                    if(res.list.length > 0){
                        let index = 0
                        let status = true

                        if(this.$route.query.d){
                            res.list.forEach((item,i) => {
                                if(item.id == this.$route.query.d && status){
                                    index = i
                                    status = false
                                }
                            })
                        }else{
                            res.list.forEach((item,i) => {
                                if(item.status - 0 === 1 && status){
                                    index = i
                                    status = false
                                }
                            })
                        }

                        this.status = res.list[index].status
                        this.id = res.list[index].id
                        this.title = res.list[index].title

                        
                        // this.getThemesDetail(id)
                        // console.log(index)
                        

                        this.getIndex(this.id)
                        this.getIndexChart(this.id)
                        // this.
                    }
                }
                console.log(res)
            })
        }
    },
    mounted() {
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

        window.addEventListener(resizeEvt, this.recalc, false);

        this.recalc()

        this.getThemes()

        const oMeta = document.createElement('meta');
        oMeta.name = "referrer";
        oMeta.content = "no-referrer"
        document.getElementsByTagName('head')[0].appendChild(oMeta);
    }
}
</script>

<style lang="less" scoped> 
    @import '../../assets/css/global.less';
    .successMask {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,0.70);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1222;

        .content {
            min-height: 290px;
            width: 400px;
            background-color: #FFF;
            box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            z-index: 99998;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: relative;

            .icon {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .title {
                font-size: 20px;
                color: @dark;
                font-weight: bold;
                text-align: center;
                justify-content: center;
                margin-top: 30px;
            }
            .msg {
                width: 80%;
                line-height: 20px;
                color: @sub;
                font-size: 14px;
                min-height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                word-break: break-all;
                margin: 10px auto 30px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-align: center;
            }

            .btns {
                height: 40px;
                align-items: center;
                display: flex;
                justify-content: center;
            }
            .confirm, .cancel {
                background-color: @bg;
                width: 120px;
                text-align: center;
                line-height: 40px;
                height: 40px;
                border-radius: 100px;
                border: 1px solid @green;
                color: @green;
                font-size: 14px;
                box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
                cursor: pointer;
                &:hover {
                    .btnHover;
                }
                &:active {
                    .btnActive;
                }
            }
            .green {
                margin-right: 20px;
                color: #fff;
                background-color: @green;
            }
        }
    }
    .themeTrack-container {
        display: flex;
        flex-direction: column;

        .content-container {
            display: flex;
            flex-direction: row;
            width: 100%;

            &.fixed {
                height: calc(100vh - 70px);
            }

            .form-container {
                display: flex;
                flex-direction: column;
                width: 874px;
                height: 100%;
                margin: 0 auto;

                .breadTab {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin: 20px 0;

                    li {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        font-size: 14px;
                        line-height: 20px;
                        color: #829191;
                        font-weight: bold;

                        &::after {
                            display: inline-flex;
                            content: '>';
                            font-size: 14px;
                            line-height: 20px;
                            margin: 0 8px;
                        }

                        &:nth-last-of-type(1) {
                            color: #050F0F;
                            &::after {
                                display: none;
                            }
                        }

                        &:nth-of-type(1) {
                            user-select: none;
                            cursor: pointer;
                        }
                    }
                }

                .form {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    // flex: 1;
                    // min-height: 0;
                    min-height: 868px;
                    margin-bottom: 50px;
                    background: #F9F9F9;
                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                    border-radius: 4px;
                    padding: 50px 10px 50px 94px;
                    box-sizing: border-box;
                    // overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 4px;
                        height: 0;
                    }
                    &::-webkit-scrollbar-thumb {
                      background: rgba(5, 15, 15, 0.4);
                      border-radius: 4px;
                    }

                    .input {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 686px;
                        margin-bottom: 14px;

                        &.on {
                            .l {
                                position: relative;

                                &::before {
                                    position: absolute;
                                    top: -2px;
                                    left: -15px;
                                    display: block;
                                    content: '*';
                                    font-size: 24px;
                                    line-height: 29px;
                                    color: #FF555A;
                                }
                            }
                        }

                        &.start {
                            align-items: flex-start;

                            .l {
                                padding-top: 10px;
                                box-sizing: border-box;

                                &::before {
                                    top: 8px;
                                }
                            }
                        }

                        &.da {
                            margin-bottom: 40px;
                        }

                        &.mb40 {
                            margin-bottom: 40px;
                        }

                        &.mb30 {
                            margin-bottom: 30px;
                        }
                        
                        .l {
                            display: flex;
                            width: 114px;
                            font-size: 14px;
                            line-height: 20px;
                            color: #829191;

                            .notice {
                                position: relative;

                                &:hover {
                                    & > i {
                                        display: block;
                                        width: 16px;
                                        height: 16px;
                                        background: url('../../assets/img/themeTrack/noticeOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }

                                    .noticeContent {
                                        display: block;
                                    }
                                }

                                & > i {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/themeTrack/notice.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-top: 2px;
                                    user-select: none;
                                    cursor: pointer;
                                }

                                .noticeContent {
                                    display: none;
                                    position: absolute;
                                    top: 30px;
                                    left: -10px;
                                    width: 515px;
                                    z-index: 999;
                                    min-height: 427px;
                                    background: rgba(30,39,34,0.89);
                                    border-radius: 10px;
                                    padding: 20px;
                                    box-sizing: border-box;

                                    img {
                                        position: absolute;
                                        top: -11px;
                                        left: 10px;
                                        width: 20px;
                                        height: 11px;
                                    }
                                    ul {
                                        display: flex;
                                        flex-direction: column;

                                        li {
                                            display: flex;
                                            flex-direction: column;
                                            margin-bottom: 14px;

                                            .ftitle {
                                                display: flex;
                                                flex-direction: row;
                                                align-items: center;
                                                font-size: 12px;
                                                line-height: 21px;
                                                color: #FFFFFF;
                                                font-weight: bold;

                                                i {
                                                    display: block;
                                                    min-width: 14px;
                                                    height: 14px;
                                                    background: #41B48C;
                                                    border-radius: 50%;
                                                    font-size: 11px;
                                                    color: #FFF;
                                                    line-height: 14px;
                                                    text-align: center;
                                                    margin-right: 10px;
                                                }
                                            }

                                            .fcontent{
                                                display: flex;
                                                flex-direction: row;
                                                align-items: center;
                                                font-size: 12px;
                                                line-height: 21px;
                                                color: #B9C3C3;
                                                margin-top: 4px;
                                                font-weight: bold;

                                                i {
                                                    display: block;
                                                    min-width: 14px;
                                                    height: 14px;
                                                    border-radius: 50%;
                                                    font-size: 11px;
                                                    color: #FFF;
                                                    line-height: 14px;
                                                    text-align: center;
                                                    margin-right: 10px;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .r {
                            display: flex;
                            flex-direction: column;
                            flex: 1;
                            min-width: 0;

                            .date {
                                height: 30px;
                            }

                            .textarea {
                                position: relative;
                                width: 100%;
                                height: 94px;
                                background: rgba(185, 195, 195, 0.2);
                                border-radius: 4px;
                                margin-bottom: 13px;

                                &.large {
                                    height: 282px;
                                }

                                textarea {
                                    width: 100%;
                                    height: 100%;
                                    outline: none;
                                    border: none;
                                    resize: none;
                                    background: transparent;
                                    padding: 10px 20px;
                                    box-sizing: border-box;

                                    &::placeholder {
                                        color: #B9C3C3;
                                    }
                                }

                                .large {
                                    position: absolute;
                                    bottom: 10px;
                                    right: 10px;
                                    display: block;
                                    width: 15px;
                                    height: 15px;
                                    background: url('../../assets/img/themeTrack/large.png') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }

                            .wordBtn {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                margin-bottom: 15px;

                                i {
                                    display: block;
                                    width: 32px;
                                    height: 32px;
                                    user-select: none;
                                    cursor: pointer;
                                    margin-right: 20px;
                                }

                                .add {
                                    background: url('../../assets/img/themeTrack/addBtn.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;

                                    &:hover {
                                        background: url('../../assets/img/themeTrack/addBtnOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }

                                .filter {
                                    background: url('../../assets/img/themeTrack/filterBtn.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;

                                    &:hover {
                                        background: url('../../assets/img/themeTrack/filterBtnOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }

                                .leftAbout {
                                    background: url('../../assets/img/themeTrack/leftAboutBtn.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;

                                    &:hover {
                                        background: url('../../assets/img/themeTrack/leftAboutBtnOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }

                                .rightAbout {
                                    background: url('../../assets/img/themeTrack/rightAboutBtn.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;

                                    &:hover {
                                        background: url('../../assets/img/themeTrack/rightAboutBtnOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }

                                span {
                                    font-size: 14px;
                                    color: #829191;
                                }
                            }

                            .inputContent {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                width: 100%;
                                height: 40px;
                                background: rgba(185, 195, 195, 0.2);
                                border-radius: 4px;
                                padding: 0 20px;
                                box-sizing: border-box;

                                input {
                                    flex: 1;
                                    min-width: 0;
                                    height: 100%;
                                    font-size: 14px;
                                    background: transparent;
                                    &::placeholder {
                                        color: #B9C3C3;
                                    }
                                }

                                p {
                                    font-size: 14px;
                                    color: #B9C3C3;
                                    font-weight: bold;
                                }
                            }

                            
                        }
                    }
                }

                .submitBtn {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin: 0 auto;

                    p {
                        width: 120px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        border-radius: 25px;
                        border: 1px solid #41B48C;
                        box-sizing: border-box;
                        font-size: 14px;
                        color: #41B48C;
                        user-select: none;
                        cursor: pointer;

                        &.un {
                            opacity: 0.6;
                        }

                        &:nth-last-of-type(2) {
                            background: #41B48C;
                            color: #FFF;
                            margin-right: 20px;
                        }
                    }
                }
            }

            .left-container {
                display: flex;
                flex-direction: column;
                width: 360px;
                height: 100%;
                padding: 30px 10px 0;
                background: #FAFBFC;
                box-sizing: border-box;
                overflow-y: auto;

                .addBtn {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    width: 256px;
                    height: 40px;
                    background: rgba(65, 180, 140, 0.1);
                    border-radius: 4px;
                    border: 1px solid #41B48C;
                    box-sizing: border-box;
                    margin: 0 auto 30px;
                    font-size: 14px;
                    font-weight: bold;
                    color: #41B48C;
                    user-select: none;
                    cursor: pointer;

                    i {
                        display: block;
                        width: 14px;
                        height: 14px;
                        background: url('../../assets/img/themeTrack/addOn.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 6px;
                    }
                }

                .titleTips {
                    font-size: 12px;
                    color: #829191;
                    line-height: 17px;
                    padding-bottom: 14px;
                    border-bottom: 1px solid #DCDCDC;
                    box-sizing: border-box;
                }

                ul {
                    display: flex;
                    flex-direction: column;
                    padding: 9px 0;
                    box-sizing: border-box;
                    width: 100%;
                    height: calc(100% - 132px);
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 4px;
                        height: 0;
                    }
                    &::-webkit-scrollbar-thumb {
                      background: rgba(5, 15, 15, 0.4);
                      border-radius: 4px;
                    }

                    li {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        min-height: 42px;
                        padding: 0 10px;
                        box-sizing: border-box;

                        &:hover {
                            background: rgba(185, 195, 195, 0.15);
                        
                            .r {
                                .date {
                                    display: none;
                                }

                                .fail {
                                    display: none;
                                }

                                .btn {
                                    display: flex;
                                }
                            }
                        }

                        &.on {
                            background: rgba(123, 216, 184, 0.15);

                            .l {
                                color: #41B48C;
                            }
                        }

                        .l {
                            width: 35%;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;
                            font-size: 14px;
                            color: #050F0F;
                            font-weight: bold;
                        }

                        .r {
                            display: flex;
                            justify-content: flex-end;
                            widows: 55%;

                            .date {
                                font-size: 12px;
                                line-height: 17px;
                                color: #050F0F;
                                font-weight: 500;
                            }

                            .btn {
                                display: none;
                                flex-direction: row;
                                align-items: center;

                                .edit {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/themeTrack/edit.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-right: 20px;

                                    &:hover {
                                        position: relative;
                                        background: url('../../assets/img/themeTrack/editOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 20px;

                                        &::after {
                                            position: absolute;
                                            top: 20px;
                                            left: -16px;
                                            display: block;
                                            content: '编辑';
                                            width: 48px;
                                            height: 32px;
                                            line-height: 32px;
                                            background-color: rgba(30,39,34,0.89);
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            font-size: 12px;
                                            color: #FFFFFF;
                                            border-radius: 8px;
                                        }
                                    }
                                }

                                .refresh {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/themeTrack/refresh.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-right: 20px;

                                    &:hover {
                                        position: relative;
                                        background: url('../../assets/img/themeTrack/refreshOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 20px;

                                        &::after {
                                            position: absolute;
                                            top: 20px;
                                            left: -16px;
                                            display: block;
                                            content: '刷新';
                                            width: 48px;
                                            height: 32px;
                                            line-height: 32px;
                                            background-color: rgba(30,39,34,0.89);
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            font-size: 12px;
                                            color: #FFFFFF;
                                            border-radius: 8px;
                                        }
                                    }
                                }

                                .del {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/themeTrack/del.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;

                                    &:hover {
                                        position: relative;
                                        background: url('../../assets/img/themeTrack/delOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;

                                        &::after {
                                            position: absolute;
                                            top: 20px;
                                            right: 0;
                                            display: block;
                                            content: '删除';
                                            width: 48px;
                                            height: 32px;
                                            line-height: 32px;
                                            background-color: rgba(30,39,34,0.89);
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            font-size: 12px;
                                            color: #FFFFFF;
                                            border-radius: 8px;
                                        }
                                    }
                                }
                            }

                            .fail {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                font-size: 12px;
                                line-height: 17px;
                                color: #FF5456;

                                i {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/themeTrack/fail.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-right: 6px;
                                }
                            }

                            .load {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                font-size: 12px;
                                line-height: 17px;
                                color: #050F0F;

                                i {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/themeTrack/load.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-right: 6px;
                                    animation: rotate360 1.2s linear infinite;
                                }
                            }
                        }
                    }
                }
            }

            .right-container {
                // width: calc(100vw - 360px);
                flex: 1;
                height: 100%;
                padding: 30px 20px 0;
                box-sizing: border-box;
                min-width: 0;

                .chart-content {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: 100%;
                    background: #F9F9F9;
                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                    overflow-y: auto;
                    padding: 0px 30px 50px;
                    box-sizing: border-box;

                    &::-webkit-scrollbar {
                        width: 4px;
                        height: 0;
                    }
                    &::-webkit-scrollbar-thumb {
                      background: rgba(5, 15, 15, 0.4);
                      border-radius: 4px;
                    }

                    &>.title {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        padding: 15px 0;
                        border-bottom: 1px solid #DCDCDC;
                        box-sizing: border-box;

                        img {
                            display: block;
                            width: 30px;
                            height: 30px;
                            margin-right: 10px;
                        }

                        span {
                            font-size: 20px;
                            line-height: 28px;
                            color: #41B48C;
                            font-weight: bold;
                        }

                        p {
                            font-size: 20px;
                            line-height: 28px;
                            color: #050F0F;
                            font-weight: bold;
                            margin-left: 10px;
                        }
                    }

                    .tips {
                        width: 100%;
                        padding: 12px 20px;
                        box-sizing: border-box;
                        background: rgba(65, 180, 140, 0.05);
                        margin-top: 13px;
                        margin-bottom: 14px;

                        p {
                            font-size: 14px;
                            line-height: 24px;
                            color: #050F0F;
                            font-weight: bold;

                            span {
                                color: #41B48C;
                                font-weight: bold;
                            }
                        }
                    }

                    .analysis {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        min-height: 2.8em;
                        background: rgba(185,195,195,0.1);
                        padding: 20px;
                        box-sizing: border-box;

                        &::after {
                            position: absolute;
                            top: 20px;
                            left: 20px;
                            display: block;
                            content: '趋势分析';
                            font-size: 18px;
                            line-height: 25px;
                            color: #050F0F;
                        }
                    } 

                    .onChart {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        min-height: 2.8em;
                        background: rgba(185,195,195,0.1);
                        padding: 0 20px;
                        box-sizing: border-box;
                        margin-bottom: 14px;

                        .title {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            padding-top: 20px;
                            box-sizing: border-box;
                            // margin-bottom: 10px;

                            .t {
                                font-size: 0.18em;
                                line-height: 1.389em;
                                color: #050F0F;
                            }

                            .b {
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                .d {
                                    position: relative;
                                    display: block;
                                    width: 28px;
                                    height: 28px;
                                    background-color: #E6EBEB;
                                    border-radius: 6px;
                                    background-image: url('../../assets/img/themeTrack/download.png');
                                    background-repeat: no-repeat;
                                    background-position: center center;
                                    background-size: 16px 16px;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        background-color: #FFFFFF;
                                        background-image: url('../../assets/img/themeTrack/downloadOn.png');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        background-size: 16px 16px;

                                        &::after {
                                            position: absolute;
                                            top: 40px;
                                            left: -10px;
                                            z-index: 9;
                                            display: block;
                                            content: '下载';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            font-size: 14px;
                                            width: max-content;
                                        }
                                    }
                                }

                                .s {
                                    position: relative;
                                    display: block;
                                    width: 28px;
                                    height: 28px;
                                    background-color: #E6EBEB;
                                    border-radius: 6px;
                                    background-image: url('../../assets/img/themeTrack/out.png');
                                    background-repeat: no-repeat;
                                    background-position: center center;
                                    background-size: 16px 16px;
                                    margin-left: 10px;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        background-color: #FFFFFF;
                                        background-image: url('../../assets/img/themeTrack/outOn.png');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        background-size: 16px 16px;

                                        &::after {
                                            position: absolute;
                                            top: 40px;
                                            left: -10px;
                                            z-index: 9;
                                            display: block;
                                            content: '导出';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            font-size: 14px;
                                            width: max-content;
                                        }
                                    }
                                }
                            }
                        }

                        .content {
                            width: 100%;
                            flex: 1;
                            min-height: 0;
                        }
                    }

                    .twoChart {
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                        min-height: 2.8em;
                        margin-bottom: 14px;

                        .one {
                            display: flex;
                            flex-direction: column;
                            flex: 1;
                            height: 100%;
                            background: rgba(185,195,195,0.1);
                            padding: 20px 0px 0;
                            box-sizing: border-box;

                            &:nth-last-of-type(1) {
                                margin-left: 14px;
                            }

                            .title {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;
                                // margin-bottom: 10px;
                                padding: 0 20px;
                                box-sizing: border-box;

                                .t {
                                    font-size: 0.18em;
                                    line-height: 1.389em;
                                    color: #050F0F;
                                }

                                .b {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;

                                    .d {
                                        position: relative;
                                        display: block;
                                        width: 28px;
                                        height: 28px;
                                        background-color: #E6EBEB;
                                        border-radius: 6px;
                                        background-image: url('../../assets/img/themeTrack/download.png');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        background-size: 16px 16px;
                                        user-select: none;
                                        cursor: pointer;

                                        &:hover {
                                            background-color: #FFFFFF;
                                            background-image: url('../../assets/img/themeTrack/downloadOn.png');
                                            background-repeat: no-repeat;
                                            background-position: center center;
                                            background-size: 16px 16px;

                                            &::after {
                                                position: absolute;
                                                top: 40px;
                                                left: -10px;
                                                z-index: 9;
                                                display: block;
                                                content: '下载';
                                                height: 32px;
                                                line-height: 32px;
                                                padding: 0 12px;
                                                box-sizing: border-box;
                                                background: rgba(30,39,34,0.89);
                                                border-radius: 8px;
                                                color: #FFF;
                                                font-size: 14px;
                                                width: max-content;
                                            }
                                        }
                                    }

                                    .s {
                                        position: relative;
                                        display: block;
                                        width: 28px;
                                        height: 28px;
                                        background-color: #E6EBEB;
                                        border-radius: 6px;
                                        background-image: url('../../assets/img/themeTrack/out.png');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        background-size: 16px 16px;
                                        margin-left: 10px;
                                        user-select: none;
                                        cursor: pointer;

                                        &:hover {
                                            background-color: #FFFFFF;
                                            background-image: url('../../assets/img/themeTrack/outOn.png');
                                            background-repeat: no-repeat;
                                            background-position: center center;
                                            background-size: 16px 16px;

                                            &::after {
                                                position: absolute;
                                                top: 40px;
                                                left: -10px;
                                                z-index: 9;
                                                display: block;
                                                content: '导出';
                                                height: 32px;
                                                line-height: 32px;
                                                padding: 0 12px;
                                                box-sizing: border-box;
                                                background: rgba(30,39,34,0.89);
                                                border-radius: 8px;
                                                color: #FFF;
                                                font-size: 14px;
                                                width: max-content;
                                            }
                                        }
                                    }
                                }
                            }

                            .content {
                                width: 100%;
                                flex: 1;
                                min-height: 0;
                                padding-left: 20px;
                                box-sizing: border-box;
                            }
                        }
                    }
                }

                .article-content {
                    display: flex;
                    flex-direction: column;

                    width: 100%;
                    height: 100%;
                    background: #F9F9F9;
                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                    

                    .right-top {
                        width: 100%;
                        padding: 0px 30px;
                        box-sizing: border-box;
                    }

                    .right-content {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        padding: 0px 30px;
                        box-sizing: border-box;
                        flex: 1;
                        min-height: 0;
                        overflow-y: auto;
                    

                        &::-webkit-scrollbar {
                            width: 4px;
                            height: 0;
                        }
                        &::-webkit-scrollbar-thumb {
                            background: rgba(5, 15, 15, 0.4);
                            border-radius: 4px;
                        }
                    }

                    .right-top >.title {
                        display: flex;
                        width: 100%;
                        justify-content: space-between;
                        align-items: center;
                        padding: 14px 0;
                        border-bottom: 1px solid #DCDCDC;
                        box-sizing: border-box;
                        margin-bottom: 13px;

                        .l {
                            font-size: 20px;
                            line-height: 28px;
                            color: #050F0F;
                            font-weight: bold;

                            &::before {
                                display: inline-flex;
                                content: '';
                                width: 9px;
                                height: 9px;
                                background: #41B48C;
                                border-radius: 50%;
                                margin-right: 10px;
                            }
                        }

                        .r {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            .word {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 143px;
                                height: 32px;
                                background: #41B48C;
                                border-radius: 4px;
                                font-size: 14px;
                                line-height: 20px;
                                color: #FFF;
                                margin-right: 10px;
                                user-select: none;
                                cursor: pointer;

                                i {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/themeTrack/report.png') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                    margin-right: 8px;
                                }
                            }

                            .out {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                font-size: 14px;
                                line-height: 20px;
                                width: 115px;
                                height: 32px;
                                border-radius: 4px;
                                border: 1px solid #41B48C;
                                box-sizing: border-box;
                                color: #41B48C;
                                user-select: none;
                                cursor: pointer;

                                i {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/themeTrack/outOn.png') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                    margin-right: 8px;
                                }
                            }
                        }
                    }

                    .searching {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        flex: 1;
                        min-height: 0;

                        .search {
                            display: flex;
                            flex-direction: column;
                            margin-bottom: 24px;

                            img {
                                width: 294px;
                                height: 186px;
                            }

                            span {
                                display: flex;
                                justify-content: center;
                                font-size: 14px;
                                line-height: 20px;
                                color: #323B4B;
                            }
                        }

                        .btn {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            p {
                                width: 120px;
                                height: 40px;
                                border-radius: 25px;
                                border: 1px solid #41B48C;
                                box-sizing: border-box;
                                font-size: 14px;
                                line-height: 40px;
                                color: #41B48C;
                                background: #FFF;
                                box-sizing: border-box;
                                text-align: center;
                                user-select: none;
                                cursor: pointer;

                                &:nth-last-of-type(1) {
                                    background: #41B48C;
                                    color: #FFF;
                                    margin-left: 20px;
                                }
                            }
                        }
                    }

                    .emptyError {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        flex: 1;
                        min-height: 0;

                        .error {
                            display: flex;
                            flex-direction: column;
                            margin-bottom: 24px;

                            img {
                                width: 96px;
                                height: 96px;
                                margin-bottom: 14px;
                            }

                            span {
                                font-size: 14px;
                                line-height: 20px;
                                color: #323B4B;
                            }
                        }

                        .btn {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            p {
                                width: 120px;
                                height: 40px;
                                border-radius: 25px;
                                border: 1px solid #41B48C;
                                box-sizing: border-box;
                                font-size: 14px;
                                line-height: 40px;
                                color: #41B48C;
                                background: #FFF;
                                box-sizing: border-box;
                                text-align: center;
                                user-select: none;
                                cursor: pointer;

                                &:nth-last-of-type(1) {
                                    background: #41B48C;
                                    color: #FFF;
                                    margin-left: 20px;
                                }
                            }
                        }
                    }

                    .tips {
                        width: 100%;
                        padding: 12px 20px;
                        box-sizing: border-box;
                        background: rgba(65, 180, 140, 0.05);
                        margin-bottom: 14px;

                        p {
                            font-size: 14px;
                            line-height: 24px;
                            color: #050F0F;
                            font-weight: bold;

                            span {
                                color: #41B48C;
                                font-weight: bold;
                            }
                        }
                    }

                    .chart-container {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        min-height: 2.8em;
                        background: rgba(185, 195, 195, 0.1);
                        margin-bottom: 13px;
                        padding: 20px 20px 0;
                        box-sizing: border-box;

                        .title {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;

                            .l {
                                font-size: 0.18em;
                                line-height: 1.389em;
                                color: #050F0F;
                            }

                            .r {
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                .d {
                                    position: relative;
                                    display: block;
                                    width: 28px;
                                    height: 28px;
                                    background-color: #E6EBEB;
                                    border-radius: 6px;
                                    background-image: url('../../assets/img/themeTrack/download.png');
                                    background-repeat: no-repeat;
                                    background-position: center center;
                                    background-size: 16px 16px;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        background-color: #FFFFFF;
                                        background-image: url('../../assets/img/themeTrack/downloadOn.png');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        background-size: 16px 16px;

                                        &::after {
                                            position: absolute;
                                            top: 40px;
                                            left: -10px;
                                            z-index: 9;
                                            display: block;
                                            content: '下载';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            font-size: 14px;
                                            width: max-content;
                                        }
                                    }
                                }

                                .s {
                                    position: relative;
                                    display: block;
                                    width: 28px;
                                    height: 28px;
                                    background-color: #E6EBEB;
                                    border-radius: 6px;
                                    background-image: url('../../assets/img/themeTrack/out.png');
                                    background-repeat: no-repeat;
                                    background-position: center center;
                                    background-size: 16px 16px;
                                    margin-left: 10px;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        background-color: #FFFFFF;
                                        background-image: url('../../assets/img/themeTrack/outOn.png');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        background-size: 16px 16px;

                                        &::after {
                                            position: absolute;
                                            top: 40px;
                                            left: -10px;
                                            z-index: 9;
                                            display: block;
                                            content: '导出';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            font-size: 14px;
                                            width: max-content;
                                        }
                                    }
                                }
                            }
                        }

                        .content {
                            width: 100%;
                            flex: 1;
                            min-height: 0;
                        }
                    }

                    .resultFrom {
                        width: 100%;
                        padding: 12px 20px;
                        box-sizing: border-box;
                        font-size: 14px;
                        line-height: 24px;
                        color: #050F0F;
                        background: rgba(65, 180, 140, 0.05);
                        margin-bottom: 14px;

                        span {
                            color: #41B48C;
                            font-weight: bold;
                        }
                    }

                    .filter-container {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-bottom: 14px;

                        &>div {
                            margin-right: 10px;
                        }

                        .all {
                            position: relative;
                            width: 122px;

                            ul {
                                position: absolute;
                                top: 35px;
                                left: 0;
                                z-index: 999;
                                display: flex;
                                flex-direction: column;
                                width: 100%;
                                background: #FFFFFF;
                                box-shadow: 4px 4px 10px 0px rgb(5 10 15 / 5%);
                                border-radius: 4px;

                                li {
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    align-items: center;
                                    width: 100%;
                                    height: 30px;
                                    padding: 0 10px;
                                    box-sizing: border-box;
                                    font-size: 14px;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        background: rgba(65, 180, 140, 0.15);
                                    }

                                    &.on {
                                        background: rgba(65, 180, 140, 0.15);

                                        i {
                                            display: block;
                                        }
                                    }

                                    i {
                                        display: none;
                                        width: 14px;
                                        height: 11px;
                                        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAAAXNSR0IArs4c6QAAAvtJREFUSEu9lF+IVFUcx7/fc3UVZyQLhX1QDISgBxX/FEIo7nUR50+EwgYhpYGkCC7O3nlQfBFEgpqdVVPBl4gwiCwttpkpmju7IIikKBL2YKkPSgTjg5gzO7t571fOzO5iOu6uutt5utxzfudzfn++X+J/XpxKniS257M7Cd4uJrp+sKwpA1qYm8ueB/QmiSHKSfjJVHHKgG4u87mE9wDMJHmP1EE/nv5kSoBuLntAUApShGQgqTzTtCwpxDvLkw50ezM7QHYLmtWYD96lmb6yFO+8Puk9dAvZjQh1UhqFVRyD1cW4d3lkOCctQzd3aI0UFDCcmcQBh0j4Sa/vUSVMCrA9l10cSOcARRtlYxXA1lLSO/W47EaBHX3HoncGa4v6NnhXnkWbGwo9rw4GwSWQcyARRMUh9hbj6c+a3VMHDgfdtN/GtHT48c5vJwKN5Y/Mq4VDlwm2CnIsjOLRUtLb87T4OtD9MZMRucOOMcCqQ64qJrp+GwtqK1Ku1H410CIBLSQrBL7zE96WseIawJ96lutB2A9oNoFQ4O1oa/T13pXbbS+eWB9dPDH9j7//6Qew3Aob4ACIs3PjC+Kn+G4wLrCRZU9aDPZDiAgYMOSZUsLb/Hiwtax1+expCOut1ggMSry6MPrKW1+0fVgbrxX/mdK23Kf9hFklaQaAinHMNj/W9fWjl7j57uOQPpAQgeG/CHHrpYhZ8X1b6u54sCeE/3ZfZu79Cq4BeLm+WR8CZ4mfTN1oVKF7n6C9ACIEQxjdcabNWPbL+l1/TQTW1GnaCz1rwzDMNdyCgYBrr7VGl/5Zrm5GEB4bsSwS9wi+4Sc8+8AJr6bCd3uzH8Nol6z5QlXQnBawCcOWZYVNx1nrx3ZfmDBp+GBTYIe+ccr5WxcMtFjCNJDVURhZNUabirH0z88Ka1rSkUti+SPzaxr6HcLskX+NzLDdj3knnwc2JtButuey7wTQV3VDsMKW2V9KpjLPCxsXaA+0FTJfIsD7JA6XEundLwKzsQ8B4ok2Jp59nfcAAAAASUVORK5CYII=') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }
                            }

                            & > p {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;
                                height: 30px;
                                line-height: 30px;
                                font-size: 14px;
                                color: #050F0F;
                                border-radius: 4px;
                                border: 1px solid #DCDCDC;
                                padding: 0 2px 0 14px;
                                box-sizing: border-box;

                                i {
                                    display: block;
                                    width: 22px;
                                    height: 30px;
                                    background: url('../../assets/img/themeTrack/downArrow.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                }
                            }
                        }

                        .time {
                            position: relative;
                            width: 122px;

                            &.un {

                                &>p {
                                    background: rgba(185,195,195,0.1000);
                                    border: 1px solid #DCDCDC;
                                    color: rgba(5,15,15,0.3);
                                }
                            }

                            ul {
                                position: absolute;
                                top: 35px;
                                left: 0;
                                z-index: 999;
                                display: flex;
                                flex-direction: column;
                                width: 100%;
                                background: #FFFFFF;
                                box-shadow: 4px 4px 10px 0px rgb(5 10 15 / 5%);
                                border-radius: 4px;

                                li {
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    align-items: center;
                                    width: 100%;
                                    height: 30px;
                                    padding: 0 10px;
                                    box-sizing: border-box;
                                    font-size: 14px;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        background: rgba(65, 180, 140, 0.15);
                                    }

                                    &.on {
                                        background: rgba(65, 180, 140, 0.15);

                                        i {
                                            display: block;
                                        }
                                    }

                                    i {
                                        display: none;
                                        width: 14px;
                                        height: 11px;
                                        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAAAXNSR0IArs4c6QAAAvtJREFUSEu9lF+IVFUcx7/fc3UVZyQLhX1QDISgBxX/FEIo7nUR50+EwgYhpYGkCC7O3nlQfBFEgpqdVVPBl4gwiCwttpkpmju7IIikKBL2YKkPSgTjg5gzO7t571fOzO5iOu6uutt5utxzfudzfn++X+J/XpxKniS257M7Cd4uJrp+sKwpA1qYm8ueB/QmiSHKSfjJVHHKgG4u87mE9wDMJHmP1EE/nv5kSoBuLntAUApShGQgqTzTtCwpxDvLkw50ezM7QHYLmtWYD96lmb6yFO+8Puk9dAvZjQh1UhqFVRyD1cW4d3lkOCctQzd3aI0UFDCcmcQBh0j4Sa/vUSVMCrA9l10cSOcARRtlYxXA1lLSO/W47EaBHX3HoncGa4v6NnhXnkWbGwo9rw4GwSWQcyARRMUh9hbj6c+a3VMHDgfdtN/GtHT48c5vJwKN5Y/Mq4VDlwm2CnIsjOLRUtLb87T4OtD9MZMRucOOMcCqQ64qJrp+GwtqK1Ku1H410CIBLSQrBL7zE96WseIawJ96lutB2A9oNoFQ4O1oa/T13pXbbS+eWB9dPDH9j7//6Qew3Aob4ACIs3PjC+Kn+G4wLrCRZU9aDPZDiAgYMOSZUsLb/Hiwtax1+expCOut1ggMSry6MPrKW1+0fVgbrxX/mdK23Kf9hFklaQaAinHMNj/W9fWjl7j57uOQPpAQgeG/CHHrpYhZ8X1b6u54sCeE/3ZfZu79Cq4BeLm+WR8CZ4mfTN1oVKF7n6C9ACIEQxjdcabNWPbL+l1/TQTW1GnaCz1rwzDMNdyCgYBrr7VGl/5Zrm5GEB4bsSwS9wi+4Sc8+8AJr6bCd3uzH8Nol6z5QlXQnBawCcOWZYVNx1nrx3ZfmDBp+GBTYIe+ccr5WxcMtFjCNJDVURhZNUabirH0z88Ka1rSkUti+SPzaxr6HcLskX+NzLDdj3knnwc2JtButuey7wTQV3VDsMKW2V9KpjLPCxsXaA+0FTJfIsD7JA6XEundLwKzsQ8B4ok2Jp59nfcAAAAASUVORK5CYII=') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }
                            }

                            & > p {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;
                                height: 30px;
                                line-height: 30px;
                                font-size: 14px;
                                color: #050F0F;
                                border-radius: 4px;
                                border: 1px solid #DCDCDC;
                                padding: 0 2px 0 14px;
                                box-sizing: border-box;

                                i {
                                    display: block;
                                    width: 22px;
                                    height: 30px;
                                    background: url('../../assets/img/themeTrack/downArrow.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                }
                            }
                        }

                        .emotion {
                            position: relative;
                            width: 122px;

                            &.un {

                                &>p {
                                    background: rgba(185,195,195,0.1000);
                                    border: 1px solid #DCDCDC;
                                    color: rgba(5,15,15,0.3);
                                }
                            }

                            ul {
                                position: absolute;
                                top: 35px;
                                left: 0;
                                z-index: 999;
                                display: flex;
                                flex-direction: column;
                                width: 100%;
                                background: #FFFFFF;
                                box-shadow: 4px 4px 10px 0px rgb(5 10 15 / 5%);
                                border-radius: 4px;

                                li {
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    align-items: center;
                                    width: 100%;
                                    height: 30px;
                                    padding: 0 10px;
                                    box-sizing: border-box;
                                    font-size: 14px;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        background: rgba(65, 180, 140, 0.15);
                                    }

                                    &.on {
                                        background: rgba(65, 180, 140, 0.15);

                                        i {
                                            display: block;
                                        }
                                    }

                                    i {
                                        display: none;
                                        width: 14px;
                                        height: 11px;
                                        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAAAXNSR0IArs4c6QAAAvtJREFUSEu9lF+IVFUcx7/fc3UVZyQLhX1QDISgBxX/FEIo7nUR50+EwgYhpYGkCC7O3nlQfBFEgpqdVVPBl4gwiCwttpkpmju7IIikKBL2YKkPSgTjg5gzO7t571fOzO5iOu6uutt5utxzfudzfn++X+J/XpxKniS257M7Cd4uJrp+sKwpA1qYm8ueB/QmiSHKSfjJVHHKgG4u87mE9wDMJHmP1EE/nv5kSoBuLntAUApShGQgqTzTtCwpxDvLkw50ezM7QHYLmtWYD96lmb6yFO+8Puk9dAvZjQh1UhqFVRyD1cW4d3lkOCctQzd3aI0UFDCcmcQBh0j4Sa/vUSVMCrA9l10cSOcARRtlYxXA1lLSO/W47EaBHX3HoncGa4v6NnhXnkWbGwo9rw4GwSWQcyARRMUh9hbj6c+a3VMHDgfdtN/GtHT48c5vJwKN5Y/Mq4VDlwm2CnIsjOLRUtLb87T4OtD9MZMRucOOMcCqQ64qJrp+GwtqK1Ku1H410CIBLSQrBL7zE96WseIawJ96lutB2A9oNoFQ4O1oa/T13pXbbS+eWB9dPDH9j7//6Qew3Aob4ACIs3PjC+Kn+G4wLrCRZU9aDPZDiAgYMOSZUsLb/Hiwtax1+expCOut1ggMSry6MPrKW1+0fVgbrxX/mdK23Kf9hFklaQaAinHMNj/W9fWjl7j57uOQPpAQgeG/CHHrpYhZ8X1b6u54sCeE/3ZfZu79Cq4BeLm+WR8CZ4mfTN1oVKF7n6C9ACIEQxjdcabNWPbL+l1/TQTW1GnaCz1rwzDMNdyCgYBrr7VGl/5Zrm5GEB4bsSwS9wi+4Sc8+8AJr6bCd3uzH8Nol6z5QlXQnBawCcOWZYVNx1nrx3ZfmDBp+GBTYIe+ccr5WxcMtFjCNJDVURhZNUabirH0z88Ka1rSkUti+SPzaxr6HcLskX+NzLDdj3knnwc2JtButuey7wTQV3VDsMKW2V9KpjLPCxsXaA+0FTJfIsD7JA6XEundLwKzsQ8B4ok2Jp59nfcAAAAASUVORK5CYII=') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }
                            }

                            & > p {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;
                                height: 30px;
                                line-height: 30px;
                                font-size: 14px;
                                color: #050F0F;
                                border-radius: 4px;
                                border: 1px solid #DCDCDC;
                                padding: 0 2px 0 14px;
                                box-sizing: border-box;

                                i {
                                    display: block;
                                    width: 22px;
                                    height: 30px;
                                    background: url('../../assets/img/themeTrack/downArrow.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                }
                            }
                        }

                        .topNum {
                            position: relative;
                            width: 140px;

                            ul {
                                position: absolute;
                                top: 35px;
                                left: 0;
                                z-index: 999;
                                display: flex;
                                flex-direction: column;
                                width: 100%;
                                background: #FFFFFF;
                                box-shadow: 4px 4px 10px 0px rgb(5 10 15 / 5%);
                                border-radius: 4px;

                                li {
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    align-items: center;
                                    width: 100%;
                                    height: 30px;
                                    padding: 0 10px;
                                    box-sizing: border-box;
                                    font-size: 14px;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        background: rgba(65, 180, 140, 0.15);
                                    }

                                    &.on {
                                        background: rgba(65, 180, 140, 0.15);

                                        i {
                                            display: block;
                                        }
                                    }

                                    i {
                                        display: none;
                                        width: 14px;
                                        height: 11px;
                                        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAAAXNSR0IArs4c6QAAAvtJREFUSEu9lF+IVFUcx7/fc3UVZyQLhX1QDISgBxX/FEIo7nUR50+EwgYhpYGkCC7O3nlQfBFEgpqdVVPBl4gwiCwttpkpmju7IIikKBL2YKkPSgTjg5gzO7t571fOzO5iOu6uutt5utxzfudzfn++X+J/XpxKniS257M7Cd4uJrp+sKwpA1qYm8ueB/QmiSHKSfjJVHHKgG4u87mE9wDMJHmP1EE/nv5kSoBuLntAUApShGQgqTzTtCwpxDvLkw50ezM7QHYLmtWYD96lmb6yFO+8Puk9dAvZjQh1UhqFVRyD1cW4d3lkOCctQzd3aI0UFDCcmcQBh0j4Sa/vUSVMCrA9l10cSOcARRtlYxXA1lLSO/W47EaBHX3HoncGa4v6NnhXnkWbGwo9rw4GwSWQcyARRMUh9hbj6c+a3VMHDgfdtN/GtHT48c5vJwKN5Y/Mq4VDlwm2CnIsjOLRUtLb87T4OtD9MZMRucOOMcCqQ64qJrp+GwtqK1Ku1H410CIBLSQrBL7zE96WseIawJ96lutB2A9oNoFQ4O1oa/T13pXbbS+eWB9dPDH9j7//6Qew3Aob4ACIs3PjC+Kn+G4wLrCRZU9aDPZDiAgYMOSZUsLb/Hiwtax1+expCOut1ggMSry6MPrKW1+0fVgbrxX/mdK23Kf9hFklaQaAinHMNj/W9fWjl7j57uOQPpAQgeG/CHHrpYhZ8X1b6u54sCeE/3ZfZu79Cq4BeLm+WR8CZ4mfTN1oVKF7n6C9ACIEQxjdcabNWPbL+l1/TQTW1GnaCz1rwzDMNdyCgYBrr7VGl/5Zrm5GEB4bsSwS9wi+4Sc8+8AJr6bCd3uzH8Nol6z5QlXQnBawCcOWZYVNx1nrx3ZfmDBp+GBTYIe+ccr5WxcMtFjCNJDVURhZNUabirH0z88Ka1rSkUti+SPzaxr6HcLskX+NzLDdj3knnwc2JtButuey7wTQV3VDsMKW2V9KpjLPCxsXaA+0FTJfIsD7JA6XEundLwKzsQ8B4ok2Jp59nfcAAAAASUVORK5CYII=') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }
                            }

                            & > p {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;
                                height: 30px;
                                line-height: 30px;
                                font-size: 14px;
                                color: #050F0F;
                                border-radius: 4px;
                                border: 1px solid #DCDCDC;
                                padding: 0 2px 0 14px;
                                box-sizing: border-box;

                                i {
                                    display: block;
                                    width: 22px;
                                    height: 30px;
                                    background: url('../../assets/img/themeTrack/downArrow.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                }
                            }
                        }
                    }

                    .list-container {
                        display: flex;
                        flex-direction: column;

                        li {
                            position: relative;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            width: 100%;
                            // min-height: 160px;
                            padding: 25px 0 15px;
                            border-top: 1px solid #F0F0F0;
                            box-sizing: border-box;

                            &>p {
                                position: absolute;
                                top: 0;
                                left: -30px;
                                padding: 6px 0 0 8px;
                                width: 34px;
                                height: 34px;
                                font-size: 18px;
                                line-height: 18px;
                                color: #FFF;
                                font-weight: bold;
                                background: url('../../assets/img/themeTrack/gArrow.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                box-sizing: border-box;

                                &.un {
                                    background: url('../../assets/img/themeTrack/greyArrow.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                }
                            }
                        }

                        .textImg {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: space-between;

                            .l {
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                flex: 1;
                                min-width: 0;

                                .title {
                                    width: 100%;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    margin-bottom: 20px;
                                    font-size: 18px;
                                    line-height: 25px;
                                    color: #050F0F;
                                    font-weight: bold;
                                }

                                .content {
                                    width: 100%;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    margin-bottom: 20px;                          
                                    font-size: 14px;
                                    line-height: 24px;
                                    color: #829191;
                                }

                                .type-container {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                flex-wrap: wrap;
                                width: 100%;
                                // text-overflow: ellipsis;
                                // white-space: nowrap;
                                // overflow-x: hidden;

                                p {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #B9C3C3; 
                                    margin-right: 26px;
                                    margin-bottom: 10px;
                                }

                                .tag {
                                    // position: relative;

                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/tagIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '类型';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .upload {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/uploadIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '发布媒体';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .user {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/userIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '作者';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .time {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/timeIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '发布时间';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .play {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/playIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '播放数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .connect {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/conIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '相似文章数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .read {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/readIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '阅读数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .see {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/seeIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '在看数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .share {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/shareIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '转发数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .comment {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/commentIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '评论数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .fav {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/favIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '点赞数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .status {
                                    // position: relative;
                                    display: flex;
                                    justify-content: center;
                                    width: 36px;
                                    height: 18px;
                                    line-height: 18px;
                                    text-align: center;
                                    font-size: 12px;
                                    border-radius: 4px;

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '情感';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }

                                    &.high {
                                        background: rgba(113, 158, 248, 0.1);
                                        border: 1px solid #719EF8;
                                        color: #719EF8;
                                        box-sizing: border-box;
                                    }

                                    &.normal {
                                        background: rgba(113, 158, 248, 0.1);
                                        border: 1px solid #71DCB1;
                                        color: #71DCB1;
                                        box-sizing: border-box;
                                    }

                                    &.low {
                                        background: rgba(113, 158, 248, 0.1);
                                        border: 1px solid #E97C63;
                                        color: #E97C63;
                                        box-sizing: border-box;
                                    }
                                }
                            }
                            }
                            .r {
                                min-width: 192px;
                                max-width: 192px;
                                height: 108px;
                                border-radius: 4px;
                                margin-left: 30px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                    background: #000;
                                }
                            }
                        }

                        .img {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;

                            .title {
                                width: 100%;
                                display: flex;
                                font-size: 18px;
                                line-height: 27px;
                                color: #050F0F;
                                font-weight: bold;
                                overflow:hidden;
                                text-overflow:ellipsis;
                                display:-webkit-box;
                                -webkit-box-orient:vertical;
                                -webkit-line-clamp:2;
                                margin-bottom: 14px;
                            }

                            .imgList {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                width: 100%;
                                height: 90px;
                                overflow: hidden;
                                margin-bottom: 14px;

                                img {
                                    width: 90px;
                                    height: 90px;
                                    margin-right: 10px;
                                }
                            }

                            .type-container {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                flex-wrap: wrap;
                                width: 100%;
                                // text-overflow: ellipsis;
                                // white-space: nowrap;
                                // overflow-x: hidden;

                                p {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #B9C3C3; 
                                    margin-right: 26px;
                                    margin-bottom: 10px;
                                }

                                .tag {
                                    // position: relative;

                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/tagIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '类型';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .upload {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/uploadIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '发布媒体';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .user {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/userIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '作者';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .time {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/timeIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '发布时间';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .play {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/playIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '播放数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .connect {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/conIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '相似文章数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .read {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/readIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '阅读数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .see {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/seeIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '在看数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .share {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/shareIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '转发数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .comment {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/commentIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '评论数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .fav {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/favIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '点赞数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .status {
                                    // position: relative;
                                    display: flex;
                                    justify-content: center;
                                    width: 36px;
                                    height: 18px;
                                    line-height: 18px;
                                    text-align: center;
                                    font-size: 12px;
                                    border-radius: 4px;

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '情感';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }

                                    &.high {
                                        background: rgba(113, 158, 248, 0.1);
                                        border: 1px solid #719EF8;
                                        color: #719EF8;
                                        box-sizing: border-box;
                                    }

                                    &.normal {
                                        background: rgba(113, 158, 248, 0.1);
                                        border: 1px solid #71DCB1;
                                        color: #71DCB1;
                                        box-sizing: border-box;
                                    }

                                    &.low {
                                        background: rgba(113, 158, 248, 0.1);
                                        border: 1px solid #E97C63;
                                        color: #E97C63;
                                        box-sizing: border-box;
                                    }
                                }
                            }
                        }

                        .text {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;

                            .title {
                                width: 100%;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                overflow: hidden;
                                margin-bottom: 20px;
                                font-size: 18px;
                                line-height: 25px;
                                color: #050F0F;
                                font-weight: bold;
                            }

                            .content {
                                width: 100%;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                overflow: hidden;
                                margin-bottom: 20px;                          
                                font-size: 14px;
                                line-height: 24px;
                                color: #829191;
                            }
                            .type-container {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                width: 100%;
                                // text-overflow: ellipsis;
                                // white-space: nowrap;
                                // overflow-x: hidden;
                                flex-wrap: wrap;

                                p {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #B9C3C3; 
                                    margin-right: 26px;
                                    margin-bottom: 10px;
                                }

                                .tag {
                                    // position: relative;

                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/tagIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '类型';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .upload {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/uploadIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '发布媒体';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .user {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/userIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '作者';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .time {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/timeIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '发布时间';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .play {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/playIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '播放数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .connect {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/conIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '相似文章数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .read {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/readIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover{
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '阅读数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .see {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/seeIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '在看数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .share {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/shareIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '转发数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .comment {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/commentIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '评论数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .fav {
                                    // position: relative;
                                    &::before {
                                        display: inline-flex;
                                        content: '';
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/themeTrack/favIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 6px;
                                    }

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '点赞数';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }
                                }

                                .status {
                                    // position: relative;
                                    display: flex;
                                    justify-content: center;
                                    width: 36px;
                                    height: 18px;
                                    line-height: 18px;
                                    text-align: center;
                                    font-size: 12px;
                                    border-radius: 4px;

                                    &:hover {
                                        &::after {
                                            position: absolute;
                                            bottom: -40px;
                                            // left: 0;
                                            z-index: 9;
                                            display: block;
                                            content: '情感';
                                            height: 32px;
                                            line-height: 32px;
                                            padding: 0 12px;
                                            box-sizing: border-box;
                                            background: rgba(30,39,34,0.89);
                                            border-radius: 8px;
                                            color: #FFF;
                                            width: max-content;
                                        }
                                    }

                                    &.high {
                                        background: rgba(113, 158, 248, 0.1);
                                        border: 1px solid #719EF8;
                                        color: #719EF8;
                                        box-sizing: border-box;
                                    }

                                    &.normal {
                                        background: rgba(113, 158, 248, 0.1);
                                        border: 1px solid #71DCB1;
                                        color: #71DCB1;
                                        box-sizing: border-box;
                                    }

                                    &.low {
                                        background: rgba(113, 158, 248, 0.1);
                                        border: 1px solid #E97C63;
                                        color: #E97C63;
                                        box-sizing: border-box;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @keyframes rotate360 {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>

<style>
.themeTrack-container .content-container .right-container .article-content .tips p em {
    color: #41B48C;
    font-style: normal;
    font-weight: bold;
}

.themeTrack-container .content-container .right-container .chart-content .tips p em {
    color: #41B48C;
    font-style: normal;
    font-weight: bold;
}

.el-date-table td.end-date span, .el-date-table td.start-date span {
    background-color: #41B48C !important;
}

.el-date-table td.today.end-date span {
    color: #FFF !important;
}
</style>